import * as c from "react";
import Ie, { forwardRef as Hn, createElement as br, useState as yr, useLayoutEffect as Ai, useEffect as Ii } from "react";
import { FormBuilder as Fi } from "@nirmata/core";
import * as Ht from "react-dom";
import Di from "react-dom";
var St = { exports: {} }, ht = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var fn;
function Mi() {
  if (fn) return ht;
  fn = 1;
  var e = Ie, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function i(s, l, u) {
    var d, f = {}, h = null, g = null;
    u !== void 0 && (h = "" + u), l.key !== void 0 && (h = "" + l.key), l.ref !== void 0 && (g = l.ref);
    for (d in l) n.call(l, d) && !a.hasOwnProperty(d) && (f[d] = l[d]);
    if (s && s.defaultProps) for (d in l = s.defaultProps, l) f[d] === void 0 && (f[d] = l[d]);
    return { $$typeof: t, type: s, key: h, ref: g, props: f, _owner: o.current };
  }
  return ht.Fragment = r, ht.jsx = i, ht.jsxs = i, ht;
}
var vt = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var pn;
function zi() {
  return pn || (pn = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Ie, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), x = Symbol.iterator, p = "@@iterator";
    function v(m) {
      if (m === null || typeof m != "object")
        return null;
      var C = x && m[x] || m[p];
      return typeof C == "function" ? C : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function b(m) {
      {
        for (var C = arguments.length, P = new Array(C > 1 ? C - 1 : 0), I = 1; I < C; I++)
          P[I - 1] = arguments[I];
        k("error", m, P);
      }
    }
    function k(m, C, P) {
      {
        var I = w.ReactDebugCurrentFrame, te = I.getStackAddendum();
        te !== "" && (C += "%s", P = P.concat([te]));
        var re = P.map(function(K) {
          return String(K);
        });
        re.unshift("Warning: " + C), Function.prototype.apply.call(console[m], console, re);
      }
    }
    var $ = !1, S = !1, O = !1, N = !1, E = !1, F;
    F = Symbol.for("react.module.reference");
    function B(m) {
      return !!(typeof m == "string" || typeof m == "function" || m === n || m === a || E || m === o || m === u || m === d || N || m === g || $ || S || O || typeof m == "object" && m !== null && (m.$$typeof === h || m.$$typeof === f || m.$$typeof === i || m.$$typeof === s || m.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      m.$$typeof === F || m.getModuleId !== void 0));
    }
    function U(m, C, P) {
      var I = m.displayName;
      if (I)
        return I;
      var te = C.displayName || C.name || "";
      return te !== "" ? P + "(" + te + ")" : P;
    }
    function q(m) {
      return m.displayName || "Context";
    }
    function L(m) {
      if (m == null)
        return null;
      if (typeof m.tag == "number" && b("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof m == "function")
        return m.displayName || m.name || null;
      if (typeof m == "string")
        return m;
      switch (m) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case a:
          return "Profiler";
        case o:
          return "StrictMode";
        case u:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof m == "object")
        switch (m.$$typeof) {
          case s:
            var C = m;
            return q(C) + ".Consumer";
          case i:
            var P = m;
            return q(P._context) + ".Provider";
          case l:
            return U(m, m.render, "ForwardRef");
          case f:
            var I = m.displayName || null;
            return I !== null ? I : L(m.type) || "Memo";
          case h: {
            var te = m, re = te._payload, K = te._init;
            try {
              return L(K(re));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var D = Object.assign, M = 0, A, z, R, Y, ce, pe, we;
    function oe() {
    }
    oe.__reactDisabledLog = !0;
    function ae() {
      {
        if (M === 0) {
          A = console.log, z = console.info, R = console.warn, Y = console.error, ce = console.group, pe = console.groupCollapsed, we = console.groupEnd;
          var m = {
            configurable: !0,
            enumerable: !0,
            value: oe,
            writable: !0
          };
          Object.defineProperties(console, {
            info: m,
            log: m,
            warn: m,
            error: m,
            group: m,
            groupCollapsed: m,
            groupEnd: m
          });
        }
        M++;
      }
    }
    function be() {
      {
        if (M--, M === 0) {
          var m = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: D({}, m, {
              value: A
            }),
            info: D({}, m, {
              value: z
            }),
            warn: D({}, m, {
              value: R
            }),
            error: D({}, m, {
              value: Y
            }),
            group: D({}, m, {
              value: ce
            }),
            groupCollapsed: D({}, m, {
              value: pe
            }),
            groupEnd: D({}, m, {
              value: we
            })
          });
        }
        M < 0 && b("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ve = w.ReactCurrentDispatcher, T;
    function G(m, C, P) {
      {
        if (T === void 0)
          try {
            throw Error();
          } catch (te) {
            var I = te.stack.trim().match(/\n( *(at )?)/);
            T = I && I[1] || "";
          }
        return `
` + T + m;
      }
    }
    var X = !1, V;
    {
      var ee = typeof WeakMap == "function" ? WeakMap : Map;
      V = new ee();
    }
    function Z(m, C) {
      if (!m || X)
        return "";
      {
        var P = V.get(m);
        if (P !== void 0)
          return P;
      }
      var I;
      X = !0;
      var te = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var re;
      re = ve.current, ve.current = null, ae();
      try {
        if (C) {
          var K = function() {
            throw Error();
          };
          if (Object.defineProperty(K.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(K, []);
            } catch (ge) {
              I = ge;
            }
            Reflect.construct(m, [], K);
          } else {
            try {
              K.call();
            } catch (ge) {
              I = ge;
            }
            m.call(K.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ge) {
            I = ge;
          }
          m();
        }
      } catch (ge) {
        if (ge && I && typeof ge.stack == "string") {
          for (var H = ge.stack.split(`
`), he = I.stack.split(`
`), le = H.length - 1, ue = he.length - 1; le >= 1 && ue >= 0 && H[le] !== he[ue]; )
            ue--;
          for (; le >= 1 && ue >= 0; le--, ue--)
            if (H[le] !== he[ue]) {
              if (le !== 1 || ue !== 1)
                do
                  if (le--, ue--, ue < 0 || H[le] !== he[ue]) {
                    var ke = `
` + H[le].replace(" at new ", " at ");
                    return m.displayName && ke.includes("<anonymous>") && (ke = ke.replace("<anonymous>", m.displayName)), typeof m == "function" && V.set(m, ke), ke;
                  }
                while (le >= 1 && ue >= 0);
              break;
            }
        }
      } finally {
        X = !1, ve.current = re, be(), Error.prepareStackTrace = te;
      }
      var rt = m ? m.displayName || m.name : "", Ke = rt ? G(rt) : "";
      return typeof m == "function" && V.set(m, Ke), Ke;
    }
    function me(m, C, P) {
      return Z(m, !1);
    }
    function Ue(m) {
      var C = m.prototype;
      return !!(C && C.isReactComponent);
    }
    function Se(m, C, P) {
      if (m == null)
        return "";
      if (typeof m == "function")
        return Z(m, Ue(m));
      if (typeof m == "string")
        return G(m);
      switch (m) {
        case u:
          return G("Suspense");
        case d:
          return G("SuspenseList");
      }
      if (typeof m == "object")
        switch (m.$$typeof) {
          case l:
            return me(m.render);
          case f:
            return Se(m.type, C, P);
          case h: {
            var I = m, te = I._payload, re = I._init;
            try {
              return Se(re(te), C, P);
            } catch {
            }
          }
        }
      return "";
    }
    var $e = Object.prototype.hasOwnProperty, Ct = {}, Rt = w.ReactDebugCurrentFrame;
    function Oe(m) {
      if (m) {
        var C = m._owner, P = Se(m.type, m._source, C ? C.type : null);
        Rt.setExtraStackFrame(P);
      } else
        Rt.setExtraStackFrame(null);
    }
    function fi(m, C, P, I, te) {
      {
        var re = Function.call.bind($e);
        for (var K in m)
          if (re(m, K)) {
            var H = void 0;
            try {
              if (typeof m[K] != "function") {
                var he = Error((I || "React class") + ": " + P + " type `" + K + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof m[K] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw he.name = "Invariant Violation", he;
              }
              H = m[K](C, K, I, P, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (le) {
              H = le;
            }
            H && !(H instanceof Error) && (Oe(te), b("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", I || "React class", P, K, typeof H), Oe(null)), H instanceof Error && !(H.message in Ct) && (Ct[H.message] = !0, Oe(te), b("Failed %s type: %s", P, H.message), Oe(null));
          }
      }
    }
    var pi = Array.isArray;
    function tr(m) {
      return pi(m);
    }
    function mi(m) {
      {
        var C = typeof Symbol == "function" && Symbol.toStringTag, P = C && m[Symbol.toStringTag] || m.constructor.name || "Object";
        return P;
      }
    }
    function hi(m) {
      try {
        return Qr(m), !1;
      } catch {
        return !0;
      }
    }
    function Qr(m) {
      return "" + m;
    }
    function en(m) {
      if (hi(m))
        return b("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", mi(m)), Qr(m);
    }
    var tn = w.ReactCurrentOwner, vi = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, rn, nn;
    function gi(m) {
      if ($e.call(m, "ref")) {
        var C = Object.getOwnPropertyDescriptor(m, "ref").get;
        if (C && C.isReactWarning)
          return !1;
      }
      return m.ref !== void 0;
    }
    function bi(m) {
      if ($e.call(m, "key")) {
        var C = Object.getOwnPropertyDescriptor(m, "key").get;
        if (C && C.isReactWarning)
          return !1;
      }
      return m.key !== void 0;
    }
    function yi(m, C) {
      typeof m.ref == "string" && tn.current;
    }
    function xi(m, C) {
      {
        var P = function() {
          rn || (rn = !0, b("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", C));
        };
        P.isReactWarning = !0, Object.defineProperty(m, "key", {
          get: P,
          configurable: !0
        });
      }
    }
    function wi(m, C) {
      {
        var P = function() {
          nn || (nn = !0, b("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", C));
        };
        P.isReactWarning = !0, Object.defineProperty(m, "ref", {
          get: P,
          configurable: !0
        });
      }
    }
    var ki = function(m, C, P, I, te, re, K) {
      var H = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: m,
        key: C,
        ref: P,
        props: K,
        // Record the component responsible for creating this element.
        _owner: re
      };
      return H._store = {}, Object.defineProperty(H._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(H, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: I
      }), Object.defineProperty(H, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: te
      }), Object.freeze && (Object.freeze(H.props), Object.freeze(H)), H;
    };
    function $i(m, C, P, I, te) {
      {
        var re, K = {}, H = null, he = null;
        P !== void 0 && (en(P), H = "" + P), bi(C) && (en(C.key), H = "" + C.key), gi(C) && (he = C.ref, yi(C, te));
        for (re in C)
          $e.call(C, re) && !vi.hasOwnProperty(re) && (K[re] = C[re]);
        if (m && m.defaultProps) {
          var le = m.defaultProps;
          for (re in le)
            K[re] === void 0 && (K[re] = le[re]);
        }
        if (H || he) {
          var ue = typeof m == "function" ? m.displayName || m.name || "Unknown" : m;
          H && xi(K, ue), he && wi(K, ue);
        }
        return ki(m, H, he, te, I, tn.current, K);
      }
    }
    var rr = w.ReactCurrentOwner, on = w.ReactDebugCurrentFrame;
    function tt(m) {
      if (m) {
        var C = m._owner, P = Se(m.type, m._source, C ? C.type : null);
        on.setExtraStackFrame(P);
      } else
        on.setExtraStackFrame(null);
    }
    var nr;
    nr = !1;
    function or(m) {
      return typeof m == "object" && m !== null && m.$$typeof === t;
    }
    function an() {
      {
        if (rr.current) {
          var m = L(rr.current.type);
          if (m)
            return `

Check the render method of \`` + m + "`.";
        }
        return "";
      }
    }
    function Ei(m) {
      return "";
    }
    var sn = {};
    function Ci(m) {
      {
        var C = an();
        if (!C) {
          var P = typeof m == "string" ? m : m.displayName || m.name;
          P && (C = `

Check the top-level render call using <` + P + ">.");
        }
        return C;
      }
    }
    function ln(m, C) {
      {
        if (!m._store || m._store.validated || m.key != null)
          return;
        m._store.validated = !0;
        var P = Ci(C);
        if (sn[P])
          return;
        sn[P] = !0;
        var I = "";
        m && m._owner && m._owner !== rr.current && (I = " It was passed a child from " + L(m._owner.type) + "."), tt(m), b('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', P, I), tt(null);
      }
    }
    function cn(m, C) {
      {
        if (typeof m != "object")
          return;
        if (tr(m))
          for (var P = 0; P < m.length; P++) {
            var I = m[P];
            or(I) && ln(I, C);
          }
        else if (or(m))
          m._store && (m._store.validated = !0);
        else if (m) {
          var te = v(m);
          if (typeof te == "function" && te !== m.entries)
            for (var re = te.call(m), K; !(K = re.next()).done; )
              or(K.value) && ln(K.value, C);
        }
      }
    }
    function Ri(m) {
      {
        var C = m.type;
        if (C == null || typeof C == "string")
          return;
        var P;
        if (typeof C == "function")
          P = C.propTypes;
        else if (typeof C == "object" && (C.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        C.$$typeof === f))
          P = C.propTypes;
        else
          return;
        if (P) {
          var I = L(C);
          fi(P, m.props, "prop", I, m);
        } else if (C.PropTypes !== void 0 && !nr) {
          nr = !0;
          var te = L(C);
          b("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", te || "Unknown");
        }
        typeof C.getDefaultProps == "function" && !C.getDefaultProps.isReactClassApproved && b("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Si(m) {
      {
        for (var C = Object.keys(m.props), P = 0; P < C.length; P++) {
          var I = C[P];
          if (I !== "children" && I !== "key") {
            tt(m), b("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", I), tt(null);
            break;
          }
        }
        m.ref !== null && (tt(m), b("Invalid attribute `ref` supplied to `React.Fragment`."), tt(null));
      }
    }
    var un = {};
    function dn(m, C, P, I, te, re) {
      {
        var K = B(m);
        if (!K) {
          var H = "";
          (m === void 0 || typeof m == "object" && m !== null && Object.keys(m).length === 0) && (H += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var he = Ei();
          he ? H += he : H += an();
          var le;
          m === null ? le = "null" : tr(m) ? le = "array" : m !== void 0 && m.$$typeof === t ? (le = "<" + (L(m.type) || "Unknown") + " />", H = " Did you accidentally export a JSX literal instead of a component?") : le = typeof m, b("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", le, H);
        }
        var ue = $i(m, C, P, te, re);
        if (ue == null)
          return ue;
        if (K) {
          var ke = C.children;
          if (ke !== void 0)
            if (I)
              if (tr(ke)) {
                for (var rt = 0; rt < ke.length; rt++)
                  cn(ke[rt], m);
                Object.freeze && Object.freeze(ke);
              } else
                b("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              cn(ke, m);
        }
        if ($e.call(C, "key")) {
          var Ke = L(m), ge = Object.keys(C).filter(function(Oi) {
            return Oi !== "key";
          }), ar = ge.length > 0 ? "{key: someKey, " + ge.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!un[Ke + ar]) {
            var _i = ge.length > 0 ? "{" + ge.join(": ..., ") + ": ...}" : "{}";
            b(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, ar, Ke, _i, Ke), un[Ke + ar] = !0;
          }
        }
        return m === n ? Si(ue) : Ri(ue), ue;
      }
    }
    function Ni(m, C, P) {
      return dn(m, C, P, !0);
    }
    function Pi(m, C, P) {
      return dn(m, C, P, !1);
    }
    var Ti = Pi, ji = Ni;
    vt.Fragment = n, vt.jsx = Ti, vt.jsxs = ji;
  }()), vt;
}
var mn;
function Li() {
  return mn || (mn = 1, process.env.NODE_ENV === "production" ? St.exports = Mi() : St.exports = zi()), St.exports;
}
var y = Li();
function qn(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (r = qn(e[t])) && (n && (n += " "), n += r);
  } else for (r in e) e[r] && (n && (n += " "), n += r);
  return n;
}
function Un() {
  for (var e, t, r = 0, n = "", o = arguments.length; r < o; r++) (e = arguments[r]) && (t = qn(e)) && (n && (n += " "), n += t);
  return n;
}
const Ar = "-", Vi = (e) => {
  const t = Bi(e), {
    conflictingClassGroups: r,
    conflictingClassGroupModifiers: n
  } = e;
  return {
    getClassGroupId: (o) => {
      const a = o.split(Ar);
      return a[0] === "" && a.length !== 1 && a.shift(), Kn(a, t) || Wi(o);
    },
    getConflictingClassGroupIds: (o, a) => {
      const i = r[o] || [];
      return a && n[o] ? [...i, ...n[o]] : i;
    }
  };
}, Kn = (e, t) => {
  var i;
  if (e.length === 0)
    return t.classGroupId;
  const r = e[0], n = t.nextPart.get(r), o = n ? Kn(e.slice(1), n) : void 0;
  if (o)
    return o;
  if (t.validators.length === 0)
    return;
  const a = e.join(Ar);
  return (i = t.validators.find(({
    validator: s
  }) => s(a))) == null ? void 0 : i.classGroupId;
}, hn = /^\[(.+)\]$/, Wi = (e) => {
  if (hn.test(e)) {
    const t = hn.exec(e)[1], r = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (r)
      return "arbitrary.." + r;
  }
}, Bi = (e) => {
  const {
    theme: t,
    classGroups: r
  } = e, n = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  for (const o in r)
    xr(r[o], n, o, t);
  return n;
}, xr = (e, t, r, n) => {
  e.forEach((o) => {
    if (typeof o == "string") {
      const a = o === "" ? t : vn(t, o);
      a.classGroupId = r;
      return;
    }
    if (typeof o == "function") {
      if (Hi(o)) {
        xr(o(n), t, r, n);
        return;
      }
      t.validators.push({
        validator: o,
        classGroupId: r
      });
      return;
    }
    Object.entries(o).forEach(([a, i]) => {
      xr(i, vn(t, a), r, n);
    });
  });
}, vn = (e, t) => {
  let r = e;
  return t.split(Ar).forEach((n) => {
    r.nextPart.has(n) || r.nextPart.set(n, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), r = r.nextPart.get(n);
  }), r;
}, Hi = (e) => e.isThemeGetter, qi = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  const o = (a, i) => {
    r.set(a, i), t++, t > e && (t = 0, n = r, r = /* @__PURE__ */ new Map());
  };
  return {
    get(a) {
      let i = r.get(a);
      if (i !== void 0)
        return i;
      if ((i = n.get(a)) !== void 0)
        return o(a, i), i;
    },
    set(a, i) {
      r.has(a) ? r.set(a, i) : o(a, i);
    }
  };
}, wr = "!", kr = ":", Ui = kr.length, Ki = (e) => {
  const {
    prefix: t,
    experimentalParseClassName: r
  } = e;
  let n = (o) => {
    const a = [];
    let i = 0, s = 0, l = 0, u;
    for (let x = 0; x < o.length; x++) {
      let p = o[x];
      if (i === 0 && s === 0) {
        if (p === kr) {
          a.push(o.slice(l, x)), l = x + Ui;
          continue;
        }
        if (p === "/") {
          u = x;
          continue;
        }
      }
      p === "[" ? i++ : p === "]" ? i-- : p === "(" ? s++ : p === ")" && s--;
    }
    const d = a.length === 0 ? o : o.substring(l), f = Gi(d), h = f !== d, g = u && u > l ? u - l : void 0;
    return {
      modifiers: a,
      hasImportantModifier: h,
      baseClassName: f,
      maybePostfixModifierPosition: g
    };
  };
  if (t) {
    const o = t + kr, a = n;
    n = (i) => i.startsWith(o) ? a(i.substring(o.length)) : {
      isExternal: !0,
      modifiers: [],
      hasImportantModifier: !1,
      baseClassName: i,
      maybePostfixModifierPosition: void 0
    };
  }
  if (r) {
    const o = n;
    n = (a) => r({
      className: a,
      parseClassName: o
    });
  }
  return n;
}, Gi = (e) => e.endsWith(wr) ? e.substring(0, e.length - 1) : e.startsWith(wr) ? e.substring(1) : e, Yi = (e) => {
  const t = Object.fromEntries(e.orderSensitiveModifiers.map((r) => [r, !0]));
  return (r) => {
    if (r.length <= 1)
      return r;
    const n = [];
    let o = [];
    return r.forEach((a) => {
      a[0] === "[" || t[a] ? (n.push(...o.sort(), a), o = []) : o.push(a);
    }), n.push(...o.sort()), n;
  };
}, Xi = (e) => ({
  cache: qi(e.cacheSize),
  parseClassName: Ki(e),
  sortModifiers: Yi(e),
  ...Vi(e)
}), Zi = /\s+/, Ji = (e, t) => {
  const {
    parseClassName: r,
    getClassGroupId: n,
    getConflictingClassGroupIds: o,
    sortModifiers: a
  } = t, i = [], s = e.trim().split(Zi);
  let l = "";
  for (let u = s.length - 1; u >= 0; u -= 1) {
    const d = s[u], {
      isExternal: f,
      modifiers: h,
      hasImportantModifier: g,
      baseClassName: x,
      maybePostfixModifierPosition: p
    } = r(d);
    if (f) {
      l = d + (l.length > 0 ? " " + l : l);
      continue;
    }
    let v = !!p, w = n(v ? x.substring(0, p) : x);
    if (!w) {
      if (!v) {
        l = d + (l.length > 0 ? " " + l : l);
        continue;
      }
      if (w = n(x), !w) {
        l = d + (l.length > 0 ? " " + l : l);
        continue;
      }
      v = !1;
    }
    const b = a(h).join(":"), k = g ? b + wr : b, $ = k + w;
    if (i.includes($))
      continue;
    i.push($);
    const S = o(w, v);
    for (let O = 0; O < S.length; ++O) {
      const N = S[O];
      i.push(k + N);
    }
    l = d + (l.length > 0 ? " " + l : l);
  }
  return l;
};
function Qi() {
  let e = 0, t, r, n = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (r = Gn(t)) && (n && (n += " "), n += r);
  return n;
}
const Gn = (e) => {
  if (typeof e == "string")
    return e;
  let t, r = "";
  for (let n = 0; n < e.length; n++)
    e[n] && (t = Gn(e[n])) && (r && (r += " "), r += t);
  return r;
};
function es(e, ...t) {
  let r, n, o, a = i;
  function i(l) {
    const u = t.reduce((d, f) => f(d), e());
    return r = Xi(u), n = r.cache.get, o = r.cache.set, a = s, s(l);
  }
  function s(l) {
    const u = n(l);
    if (u)
      return u;
    const d = Ji(l, r);
    return o(l, d), d;
  }
  return function() {
    return a(Qi.apply(null, arguments));
  };
}
const de = (e) => {
  const t = (r) => r[e] || [];
  return t.isThemeGetter = !0, t;
}, Yn = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, Xn = /^\((?:(\w[\w-]*):)?(.+)\)$/i, ts = /^\d+\/\d+$/, rs = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, ns = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, os = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, as = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, is = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, nt = (e) => ts.test(e), W = (e) => !!e && !Number.isNaN(Number(e)), Me = (e) => !!e && Number.isInteger(Number(e)), ir = (e) => e.endsWith("%") && W(e.slice(0, -1)), Ae = (e) => rs.test(e), ss = () => !0, ls = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  ns.test(e) && !os.test(e)
), Zn = () => !1, cs = (e) => as.test(e), us = (e) => is.test(e), ds = (e) => !j(e) && !_(e), fs = (e) => ut(e, eo, Zn), j = (e) => Yn.test(e), Ge = (e) => ut(e, to, ls), sr = (e) => ut(e, gs, W), gn = (e) => ut(e, Jn, Zn), ps = (e) => ut(e, Qn, us), Nt = (e) => ut(e, ro, cs), _ = (e) => Xn.test(e), gt = (e) => dt(e, to), ms = (e) => dt(e, bs), bn = (e) => dt(e, Jn), hs = (e) => dt(e, eo), vs = (e) => dt(e, Qn), Pt = (e) => dt(e, ro, !0), ut = (e, t, r) => {
  const n = Yn.exec(e);
  return n ? n[1] ? t(n[1]) : r(n[2]) : !1;
}, dt = (e, t, r = !1) => {
  const n = Xn.exec(e);
  return n ? n[1] ? t(n[1]) : r : !1;
}, Jn = (e) => e === "position" || e === "percentage", Qn = (e) => e === "image" || e === "url", eo = (e) => e === "length" || e === "size" || e === "bg-size", to = (e) => e === "length", gs = (e) => e === "number", bs = (e) => e === "family-name", ro = (e) => e === "shadow", ys = () => {
  const e = de("color"), t = de("font"), r = de("text"), n = de("font-weight"), o = de("tracking"), a = de("leading"), i = de("breakpoint"), s = de("container"), l = de("spacing"), u = de("radius"), d = de("shadow"), f = de("inset-shadow"), h = de("text-shadow"), g = de("drop-shadow"), x = de("blur"), p = de("perspective"), v = de("aspect"), w = de("ease"), b = de("animate"), k = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], $ = () => [
    "center",
    "top",
    "bottom",
    "left",
    "right",
    "top-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-top",
    "top-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-top",
    "bottom-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-bottom",
    "bottom-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-bottom"
  ], S = () => [...$(), _, j], O = () => ["auto", "hidden", "clip", "visible", "scroll"], N = () => ["auto", "contain", "none"], E = () => [_, j, l], F = () => [nt, "full", "auto", ...E()], B = () => [Me, "none", "subgrid", _, j], U = () => ["auto", {
    span: ["full", Me, _, j]
  }, Me, _, j], q = () => [Me, "auto", _, j], L = () => ["auto", "min", "max", "fr", _, j], D = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline", "center-safe", "end-safe"], M = () => ["start", "end", "center", "stretch", "center-safe", "end-safe"], A = () => ["auto", ...E()], z = () => [nt, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...E()], R = () => [e, _, j], Y = () => [...$(), bn, gn, {
    position: [_, j]
  }], ce = () => ["no-repeat", {
    repeat: ["", "x", "y", "space", "round"]
  }], pe = () => ["auto", "cover", "contain", hs, fs, {
    size: [_, j]
  }], we = () => [ir, gt, Ge], oe = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    "full",
    u,
    _,
    j
  ], ae = () => ["", W, gt, Ge], be = () => ["solid", "dashed", "dotted", "double"], ve = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], T = () => [W, ir, bn, gn], G = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    x,
    _,
    j
  ], X = () => ["none", W, _, j], V = () => ["none", W, _, j], ee = () => [W, _, j], Z = () => [nt, "full", ...E()];
  return {
    cacheSize: 500,
    theme: {
      animate: ["spin", "ping", "pulse", "bounce"],
      aspect: ["video"],
      blur: [Ae],
      breakpoint: [Ae],
      color: [ss],
      container: [Ae],
      "drop-shadow": [Ae],
      ease: ["in", "out", "in-out"],
      font: [ds],
      "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
      "inset-shadow": [Ae],
      leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
      perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
      radius: [Ae],
      shadow: [Ae],
      spacing: ["px", W],
      text: [Ae],
      "text-shadow": [Ae],
      tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
    },
    classGroups: {
      // --------------
      // --- Layout ---
      // --------------
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", nt, j, _, v]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [W, j, _, s]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": k()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": k()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: S()
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: O()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": O()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": O()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: N()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": N()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": N()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: F()
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": F()
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": F()
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: F()
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: F()
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: F()
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: F()
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: F()
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: F()
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [Me, "auto", _, j]
      }],
      // ------------------------
      // --- Flexbox and Grid ---
      // ------------------------
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [nt, "full", "auto", s, ...E()]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["nowrap", "wrap", "wrap-reverse"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: [W, nt, "auto", "initial", "none", j]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ["", W, _, j]
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ["", W, _, j]
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: [Me, "first", "last", "none", _, j]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": B()
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: U()
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": q()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": q()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": B()
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: U()
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": q()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": q()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": L()
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": L()
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: E()
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": E()
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": E()
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: [...D(), "normal"]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": [...M(), "normal"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", ...M()]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...D()]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: [...M(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", ...M(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": D()
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": [...M(), "baseline"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", ...M()]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: E()
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: E()
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: E()
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: E()
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: E()
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: E()
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: E()
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: E()
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: E()
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: A()
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: A()
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: A()
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: A()
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: A()
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: A()
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: A()
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: A()
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: A()
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x": [{
        "space-x": E()
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y": [{
        "space-y": E()
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y-reverse": ["space-y-reverse"],
      // --------------
      // --- Sizing ---
      // --------------
      /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */
      size: [{
        size: z()
      }],
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: [s, "screen", ...z()]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [
          s,
          "screen",
          /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "none",
          ...z()
        ]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [
          s,
          "screen",
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "prose",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          {
            screen: [i]
          },
          ...z()
        ]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: ["screen", "lh", ...z()]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["screen", "lh", "none", ...z()]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": ["screen", "lh", ...z()]
      }],
      // ------------------
      // --- Typography ---
      // ------------------
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", r, gt, Ge]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: [n, _, sr]
      }],
      /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */
      "font-stretch": [{
        "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", ir, j]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [ms, j, t]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: [o, _, j]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": [W, "none", _, sr]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: [
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          a,
          ...E()
        ]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", _, j]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["disc", "decimal", "none", _, j]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: R()
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: R()
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...be(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: [W, "from-font", "auto", _, Ge]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: R()
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": [W, "auto", _, j]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: E()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", _, j]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */
      wrap: [{
        wrap: ["break-word", "anywhere", "normal"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", _, j]
      }],
      // -------------------
      // --- Backgrounds ---
      // -------------------
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: Y()
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ce()
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: pe()
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          linear: [{
            to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, Me, _, j],
          radial: ["", _, j],
          conic: [Me, _, j]
        }, vs, ps]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: R()
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: we()
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: we()
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: we()
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: R()
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: R()
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: R()
      }],
      // ---------------
      // --- Borders ---
      // ---------------
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: oe()
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": oe()
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": oe()
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": oe()
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": oe()
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": oe()
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": oe()
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": oe()
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": oe()
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": oe()
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": oe()
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": oe()
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": oe()
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": oe()
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": oe()
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: ae()
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": ae()
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": ae()
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": ae()
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": ae()
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": ae()
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": ae()
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": ae()
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": ae()
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x": [{
        "divide-x": ae()
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y": [{
        "divide-y": ae()
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...be(), "hidden", "none"]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */
      "divide-style": [{
        divide: [...be(), "hidden", "none"]
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: R()
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": R()
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": R()
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": R()
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": R()
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": R()
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": R()
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": R()
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": R()
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: R()
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [...be(), "none", "hidden"]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [W, _, j]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: ["", W, gt, Ge]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: R()
      }],
      // ---------------
      // --- Effects ---
      // ---------------
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          d,
          Pt,
          Nt
        ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */
      "shadow-color": [{
        shadow: R()
      }],
      /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */
      "inset-shadow": [{
        "inset-shadow": ["none", f, Pt, Nt]
      }],
      /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */
      "inset-shadow-color": [{
        "inset-shadow": R()
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */
      "ring-w": [{
        ring: ae()
      }],
      /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */
      "ring-color": [{
        ring: R()
      }],
      /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-w": [{
        "ring-offset": [W, Ge]
      }],
      /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-color": [{
        "ring-offset": R()
      }],
      /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */
      "inset-ring-w": [{
        "inset-ring": ae()
      }],
      /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */
      "inset-ring-color": [{
        "inset-ring": R()
      }],
      /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */
      "text-shadow": [{
        "text-shadow": ["none", h, Pt, Nt]
      }],
      /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */
      "text-shadow-color": [{
        "text-shadow": R()
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [W, _, j]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...ve(), "plus-darker", "plus-lighter"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": ve()
      }],
      /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */
      "mask-clip": [{
        "mask-clip": ["border", "padding", "content", "fill", "stroke", "view"]
      }, "mask-no-clip"],
      /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */
      "mask-composite": [{
        mask: ["add", "subtract", "intersect", "exclude"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image-linear-pos": [{
        "mask-linear": [W]
      }],
      "mask-image-linear-from-pos": [{
        "mask-linear-from": T()
      }],
      "mask-image-linear-to-pos": [{
        "mask-linear-to": T()
      }],
      "mask-image-linear-from-color": [{
        "mask-linear-from": R()
      }],
      "mask-image-linear-to-color": [{
        "mask-linear-to": R()
      }],
      "mask-image-t-from-pos": [{
        "mask-t-from": T()
      }],
      "mask-image-t-to-pos": [{
        "mask-t-to": T()
      }],
      "mask-image-t-from-color": [{
        "mask-t-from": R()
      }],
      "mask-image-t-to-color": [{
        "mask-t-to": R()
      }],
      "mask-image-r-from-pos": [{
        "mask-r-from": T()
      }],
      "mask-image-r-to-pos": [{
        "mask-r-to": T()
      }],
      "mask-image-r-from-color": [{
        "mask-r-from": R()
      }],
      "mask-image-r-to-color": [{
        "mask-r-to": R()
      }],
      "mask-image-b-from-pos": [{
        "mask-b-from": T()
      }],
      "mask-image-b-to-pos": [{
        "mask-b-to": T()
      }],
      "mask-image-b-from-color": [{
        "mask-b-from": R()
      }],
      "mask-image-b-to-color": [{
        "mask-b-to": R()
      }],
      "mask-image-l-from-pos": [{
        "mask-l-from": T()
      }],
      "mask-image-l-to-pos": [{
        "mask-l-to": T()
      }],
      "mask-image-l-from-color": [{
        "mask-l-from": R()
      }],
      "mask-image-l-to-color": [{
        "mask-l-to": R()
      }],
      "mask-image-x-from-pos": [{
        "mask-x-from": T()
      }],
      "mask-image-x-to-pos": [{
        "mask-x-to": T()
      }],
      "mask-image-x-from-color": [{
        "mask-x-from": R()
      }],
      "mask-image-x-to-color": [{
        "mask-x-to": R()
      }],
      "mask-image-y-from-pos": [{
        "mask-y-from": T()
      }],
      "mask-image-y-to-pos": [{
        "mask-y-to": T()
      }],
      "mask-image-y-from-color": [{
        "mask-y-from": R()
      }],
      "mask-image-y-to-color": [{
        "mask-y-to": R()
      }],
      "mask-image-radial": [{
        "mask-radial": [_, j]
      }],
      "mask-image-radial-from-pos": [{
        "mask-radial-from": T()
      }],
      "mask-image-radial-to-pos": [{
        "mask-radial-to": T()
      }],
      "mask-image-radial-from-color": [{
        "mask-radial-from": R()
      }],
      "mask-image-radial-to-color": [{
        "mask-radial-to": R()
      }],
      "mask-image-radial-shape": [{
        "mask-radial": ["circle", "ellipse"]
      }],
      "mask-image-radial-size": [{
        "mask-radial": [{
          closest: ["side", "corner"],
          farthest: ["side", "corner"]
        }]
      }],
      "mask-image-radial-pos": [{
        "mask-radial-at": $()
      }],
      "mask-image-conic-pos": [{
        "mask-conic": [W]
      }],
      "mask-image-conic-from-pos": [{
        "mask-conic-from": T()
      }],
      "mask-image-conic-to-pos": [{
        "mask-conic-to": T()
      }],
      "mask-image-conic-from-color": [{
        "mask-conic-from": R()
      }],
      "mask-image-conic-to-color": [{
        "mask-conic-to": R()
      }],
      /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */
      "mask-mode": [{
        mask: ["alpha", "luminance", "match"]
      }],
      /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */
      "mask-origin": [{
        "mask-origin": ["border", "padding", "content", "fill", "stroke", "view"]
      }],
      /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */
      "mask-position": [{
        mask: Y()
      }],
      /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */
      "mask-repeat": [{
        mask: ce()
      }],
      /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */
      "mask-size": [{
        mask: pe()
      }],
      /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */
      "mask-type": [{
        "mask-type": ["alpha", "luminance"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image": [{
        mask: ["none", _, j]
      }],
      // ---------------
      // --- Filters ---
      // ---------------
      /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          _,
          j
        ]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: G()
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [W, _, j]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [W, _, j]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          g,
          Pt,
          Nt
        ]
      }],
      /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */
      "drop-shadow-color": [{
        "drop-shadow": R()
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: ["", W, _, j]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [W, _, j]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: ["", W, _, j]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [W, _, j]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: ["", W, _, j]
      }],
      /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          _,
          j
        ]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": G()
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [W, _, j]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [W, _, j]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": ["", W, _, j]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [W, _, j]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": ["", W, _, j]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [W, _, j]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [W, _, j]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": ["", W, _, j]
      }],
      // --------------
      // --- Tables ---
      // --------------
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": E()
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": E()
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": E()
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // ---------------------------------
      // --- Transitions and Animation ---
      // ---------------------------------
      /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", _, j]
      }],
      /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */
      "transition-behavior": [{
        transition: ["normal", "discrete"]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [W, "initial", _, j]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "initial", w, _, j]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [W, _, j]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", b, _, j]
      }],
      // ------------------
      // --- Transforms ---
      // ------------------
      /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */
      backface: [{
        backface: ["hidden", "visible"]
      }],
      /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */
      perspective: [{
        perspective: [p, _, j]
      }],
      /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */
      "perspective-origin": [{
        "perspective-origin": S()
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: X()
      }],
      /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-x": [{
        "rotate-x": X()
      }],
      /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-y": [{
        "rotate-y": X()
      }],
      /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-z": [{
        "rotate-z": X()
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: V()
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": V()
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": V()
      }],
      /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-z": [{
        "scale-z": V()
      }],
      /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-3d": ["scale-3d"],
      /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */
      skew: [{
        skew: ee()
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": ee()
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": ee()
      }],
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: [_, j, "", "none", "gpu", "cpu"]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: S()
      }],
      /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */
      "transform-style": [{
        transform: ["3d", "flat"]
      }],
      /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */
      translate: [{
        translate: Z()
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": Z()
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": Z()
      }],
      /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-z": [{
        "translate-z": Z()
      }],
      /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-none": ["translate-none"],
      // ---------------------
      // --- Interactivity ---
      // ---------------------
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: R()
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: R()
      }],
      /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */
      "color-scheme": [{
        scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", _, j]
      }],
      /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */
      "field-sizing": [{
        "field-sizing": ["fixed", "content"]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["auto", "none"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "", "y", "x"]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": E()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": E()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": E()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": E()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": E()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": E()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": E()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": E()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": E()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": E()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": E()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": E()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": E()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": E()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": E()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": E()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": E()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": E()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", _, j]
      }],
      // -----------
      // --- SVG ---
      // -----------
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: ["none", ...R()]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [W, gt, Ge, sr]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: ["none", ...R()]
      }],
      // ---------------------
      // --- Accessibility ---
      // ---------------------
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-x", "border-w-y", "border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-x", "border-color-y", "border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      translate: ["translate-x", "translate-y", "translate-none"],
      "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    },
    orderSensitiveModifiers: ["*", "**", "after", "backdrop", "before", "details-content", "file", "first-letter", "first-line", "marker", "placeholder", "selection"]
  };
}, xs = /* @__PURE__ */ es(ys);
function ne(...e) {
  return xs(Un(e));
}
const yn = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, xn = Un, se = (e, t) => (r) => {
  var n;
  if ((t == null ? void 0 : t.variants) == null) return xn(e, r == null ? void 0 : r.class, r == null ? void 0 : r.className);
  const { variants: o, defaultVariants: a } = t, i = Object.keys(o).map((u) => {
    const d = r == null ? void 0 : r[u], f = a == null ? void 0 : a[u];
    if (d === null) return null;
    const h = yn(d) || yn(f);
    return o[u][h];
  }), s = r && Object.entries(r).reduce((u, d) => {
    let [f, h] = d;
    return h === void 0 || (u[f] = h), u;
  }, {}), l = t == null || (n = t.compoundVariants) === null || n === void 0 ? void 0 : n.reduce((u, d) => {
    let { class: f, className: h, ...g } = d;
    return Object.entries(g).every((x) => {
      let [p, v] = x;
      return Array.isArray(v) ? v.includes({
        ...a,
        ...s
      }[p]) : {
        ...a,
        ...s
      }[p] === v;
    }) ? [
      ...u,
      f,
      h
    ] : u;
  }, []);
  return xn(e, i, l, r == null ? void 0 : r.class, r == null ? void 0 : r.className);
};
function wn(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function no(...e) {
  return (t) => {
    let r = !1;
    const n = e.map((o) => {
      const a = wn(o, t);
      return !r && typeof a == "function" && (r = !0), a;
    });
    if (r)
      return () => {
        for (let o = 0; o < n.length; o++) {
          const a = n[o];
          typeof a == "function" ? a() : wn(e[o], null);
        }
      };
  };
}
function ie(...e) {
  return c.useCallback(no(...e), e);
}
// @__NO_SIDE_EFFECTS__
function yt(e) {
  const t = /* @__PURE__ */ ks(e), r = c.forwardRef((n, o) => {
    const { children: a, ...i } = n, s = c.Children.toArray(a), l = s.find(Es);
    if (l) {
      const u = l.props.children, d = s.map((f) => f === l ? c.Children.count(u) > 1 ? c.Children.only(null) : c.isValidElement(u) ? u.props.children : null : f);
      return /* @__PURE__ */ y.jsx(t, { ...i, ref: o, children: c.isValidElement(u) ? c.cloneElement(u, void 0, d) : null });
    }
    return /* @__PURE__ */ y.jsx(t, { ...i, ref: o, children: a });
  });
  return r.displayName = `${e}.Slot`, r;
}
var ws = /* @__PURE__ */ yt("Slot");
// @__NO_SIDE_EFFECTS__
function ks(e) {
  const t = c.forwardRef((r, n) => {
    const { children: o, ...a } = r;
    if (c.isValidElement(o)) {
      const i = Rs(o), s = Cs(a, o.props);
      return o.type !== c.Fragment && (s.ref = n ? no(n, i) : i), c.cloneElement(o, s);
    }
    return c.Children.count(o) > 1 ? c.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var $s = Symbol("radix.slottable");
function Es(e) {
  return c.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === $s;
}
function Cs(e, t) {
  const r = { ...t };
  for (const n in t) {
    const o = e[n], a = t[n];
    /^on[A-Z]/.test(n) ? o && a ? r[n] = (...i) => {
      const s = a(...i);
      return o(...i), s;
    } : o && (r[n] = o) : n === "style" ? r[n] = { ...o, ...a } : n === "className" && (r[n] = [o, a].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function Rs(e) {
  var n, o;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
function et(e, t = []) {
  let r = [];
  function n(a, i) {
    const s = c.createContext(i), l = r.length;
    r = [...r, i];
    const u = (f) => {
      var w;
      const { scope: h, children: g, ...x } = f, p = ((w = h == null ? void 0 : h[e]) == null ? void 0 : w[l]) || s, v = c.useMemo(() => x, Object.values(x));
      return /* @__PURE__ */ y.jsx(p.Provider, { value: v, children: g });
    };
    u.displayName = a + "Provider";
    function d(f, h) {
      var p;
      const g = ((p = h == null ? void 0 : h[e]) == null ? void 0 : p[l]) || s, x = c.useContext(g);
      if (x) return x;
      if (i !== void 0) return i;
      throw new Error(`\`${f}\` must be used within \`${a}\``);
    }
    return [u, d];
  }
  const o = () => {
    const a = r.map((i) => c.createContext(i));
    return function(i) {
      const s = (i == null ? void 0 : i[e]) || a;
      return c.useMemo(
        () => ({ [`__scope${e}`]: { ...i, [e]: s } }),
        [i, s]
      );
    };
  };
  return o.scopeName = e, [n, Ss(o, ...t)];
}
function Ss(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const n = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(o) {
      const a = n.reduce((i, { useScope: s, scopeName: l }) => {
        const u = s(o)[`__scope${l}`];
        return { ...i, ...u };
      }, {});
      return c.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return r.scopeName = t.scopeName, r;
}
function J(e, t, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(n) {
    if (e == null || e(n), r === !1 || !n.defaultPrevented)
      return t == null ? void 0 : t(n);
  };
}
var fe = globalThis != null && globalThis.document ? c.useLayoutEffect : () => {
}, Ns = c[" useInsertionEffect ".trim().toString()] || fe;
function xt({
  prop: e,
  defaultProp: t,
  onChange: r = () => {
  },
  caller: n
}) {
  const [o, a, i] = Ps({
    defaultProp: t,
    onChange: r
  }), s = e !== void 0, l = s ? e : o;
  {
    const d = c.useRef(e !== void 0);
    c.useEffect(() => {
      const f = d.current;
      f !== s && console.warn(
        `${n} is changing from ${f ? "controlled" : "uncontrolled"} to ${s ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), d.current = s;
    }, [s, n]);
  }
  const u = c.useCallback(
    (d) => {
      var f;
      if (s) {
        const h = Ts(d) ? d(e) : d;
        h !== e && ((f = i.current) == null || f.call(i, h));
      } else
        a(d);
    },
    [s, e, a, i]
  );
  return [l, u];
}
function Ps({
  defaultProp: e,
  onChange: t
}) {
  const [r, n] = c.useState(e), o = c.useRef(r), a = c.useRef(t);
  return Ns(() => {
    a.current = t;
  }, [t]), c.useEffect(() => {
    var i;
    o.current !== r && ((i = a.current) == null || i.call(a, r), o.current = r);
  }, [r, o]), [r, n, a];
}
function Ts(e) {
  return typeof e == "function";
}
function Ir(e) {
  const t = c.useRef({ value: e, previous: e });
  return c.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
function Fr(e) {
  const [t, r] = c.useState(void 0);
  return fe(() => {
    if (e) {
      r({ width: e.offsetWidth, height: e.offsetHeight });
      const n = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const a = o[0];
        let i, s;
        if ("borderBoxSize" in a) {
          const l = a.borderBoxSize, u = Array.isArray(l) ? l[0] : l;
          i = u.inlineSize, s = u.blockSize;
        } else
          i = e.offsetWidth, s = e.offsetHeight;
        r({ width: i, height: s });
      });
      return n.observe(e, { box: "border-box" }), () => n.unobserve(e);
    } else
      r(void 0);
  }, [e]), t;
}
function js(e, t) {
  return c.useReducer((r, n) => t[r][n] ?? r, e);
}
var Dr = (e) => {
  const { present: t, children: r } = e, n = _s(t), o = typeof r == "function" ? r({ present: n.isPresent }) : c.Children.only(r), a = ie(n.ref, Os(o));
  return typeof r == "function" || n.isPresent ? c.cloneElement(o, { ref: a }) : null;
};
Dr.displayName = "Presence";
function _s(e) {
  const [t, r] = c.useState(), n = c.useRef(null), o = c.useRef(e), a = c.useRef("none"), i = e ? "mounted" : "unmounted", [s, l] = js(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return c.useEffect(() => {
    const u = Tt(n.current);
    a.current = s === "mounted" ? u : "none";
  }, [s]), fe(() => {
    const u = n.current, d = o.current;
    if (d !== e) {
      const f = a.current, h = Tt(u);
      e ? l("MOUNT") : h === "none" || (u == null ? void 0 : u.display) === "none" ? l("UNMOUNT") : l(d && f !== h ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, l]), fe(() => {
    if (t) {
      let u;
      const d = t.ownerDocument.defaultView ?? window, f = (g) => {
        const x = Tt(n.current).includes(g.animationName);
        if (g.target === t && x && (l("ANIMATION_END"), !o.current)) {
          const p = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", u = d.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = p);
          });
        }
      }, h = (g) => {
        g.target === t && (a.current = Tt(n.current));
      };
      return t.addEventListener("animationstart", h), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        d.clearTimeout(u), t.removeEventListener("animationstart", h), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: c.useCallback((u) => {
      n.current = u ? getComputedStyle(u) : null, r(u);
    }, [])
  };
}
function Tt(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Os(e) {
  var n, o;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var As = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Q = As.reduce((e, t) => {
  const r = /* @__PURE__ */ yt(`Primitive.${t}`), n = c.forwardRef((o, a) => {
    const { asChild: i, ...s } = o, l = i ? r : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ y.jsx(l, { ...s, ref: a });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function Is(e, t) {
  e && Ht.flushSync(() => e.dispatchEvent(t));
}
/**
 * @license lucide-react v0.503.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fs = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), Ds = (e) => e.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (t, r, n) => n ? n.toUpperCase() : r.toLowerCase()
), kn = (e) => {
  const t = Ds(e);
  return t.charAt(0).toUpperCase() + t.slice(1);
}, oo = (...e) => e.filter((t, r, n) => !!t && t.trim() !== "" && n.indexOf(t) === r).join(" ").trim(), Ms = (e) => {
  for (const t in e)
    if (t.startsWith("aria-") || t === "role" || t === "title")
      return !0;
};
/**
 * @license lucide-react v0.503.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var zs = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.503.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ls = Hn(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: r = 2,
    absoluteStrokeWidth: n,
    className: o = "",
    children: a,
    iconNode: i,
    ...s
  }, l) => br(
    "svg",
    {
      ref: l,
      ...zs,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: n ? Number(r) * 24 / Number(t) : r,
      className: oo("lucide", o),
      ...!a && !Ms(s) && { "aria-hidden": "true" },
      ...s
    },
    [
      ...i.map(([u, d]) => br(u, d)),
      ...Array.isArray(a) ? a : [a]
    ]
  )
);
/**
 * @license lucide-react v0.503.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mr = (e, t) => {
  const r = Hn(
    ({ className: n, ...o }, a) => br(Ls, {
      ref: a,
      iconNode: t,
      className: oo(
        `lucide-${Fs(kn(e))}`,
        `lucide-${e}`,
        n
      ),
      ...o
    })
  );
  return r.displayName = kn(e), r;
};
/**
 * @license lucide-react v0.503.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vs = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], ao = Mr("check", Vs);
var qt = "Checkbox", [Ws, Qd] = et(qt), [Bs, zr] = Ws(qt);
function Hs(e) {
  const {
    __scopeCheckbox: t,
    checked: r,
    children: n,
    defaultChecked: o,
    disabled: a,
    form: i,
    name: s,
    onCheckedChange: l,
    required: u,
    value: d = "on",
    // @ts-expect-error
    internal_do_not_use_render: f
  } = e, [h, g] = xt({
    prop: r,
    defaultProp: o ?? !1,
    onChange: l,
    caller: qt
  }), [x, p] = c.useState(null), [v, w] = c.useState(null), b = c.useRef(!1), k = x ? !!i || !!x.closest("form") : (
    // We set this to true by default so that events bubble to forms without JS (SSR)
    !0
  ), $ = {
    checked: h,
    disabled: a,
    setChecked: g,
    control: x,
    setControl: p,
    name: s,
    form: i,
    value: d,
    hasConsumerStoppedPropagationRef: b,
    required: u,
    defaultChecked: Le(o) ? !1 : o,
    isFormControl: k,
    bubbleInput: v,
    setBubbleInput: w
  };
  return /* @__PURE__ */ y.jsx(
    Bs,
    {
      scope: t,
      ...$,
      children: qs(f) ? f($) : n
    }
  );
}
var io = "CheckboxTrigger", so = c.forwardRef(
  ({ __scopeCheckbox: e, onKeyDown: t, onClick: r, ...n }, o) => {
    const {
      control: a,
      value: i,
      disabled: s,
      checked: l,
      required: u,
      setControl: d,
      setChecked: f,
      hasConsumerStoppedPropagationRef: h,
      isFormControl: g,
      bubbleInput: x
    } = zr(io, e), p = ie(o, d), v = c.useRef(l);
    return c.useEffect(() => {
      const w = a == null ? void 0 : a.form;
      if (w) {
        const b = () => f(v.current);
        return w.addEventListener("reset", b), () => w.removeEventListener("reset", b);
      }
    }, [a, f]), /* @__PURE__ */ y.jsx(
      Q.button,
      {
        type: "button",
        role: "checkbox",
        "aria-checked": Le(l) ? "mixed" : l,
        "aria-required": u,
        "data-state": po(l),
        "data-disabled": s ? "" : void 0,
        disabled: s,
        value: i,
        ...n,
        ref: p,
        onKeyDown: J(t, (w) => {
          w.key === "Enter" && w.preventDefault();
        }),
        onClick: J(r, (w) => {
          f((b) => Le(b) ? !0 : !b), x && g && (h.current = w.isPropagationStopped(), h.current || w.stopPropagation());
        })
      }
    );
  }
);
so.displayName = io;
var Lr = c.forwardRef(
  (e, t) => {
    const {
      __scopeCheckbox: r,
      name: n,
      checked: o,
      defaultChecked: a,
      required: i,
      disabled: s,
      value: l,
      onCheckedChange: u,
      form: d,
      ...f
    } = e;
    return /* @__PURE__ */ y.jsx(
      Hs,
      {
        __scopeCheckbox: r,
        checked: o,
        defaultChecked: a,
        disabled: s,
        required: i,
        onCheckedChange: u,
        name: n,
        form: d,
        value: l,
        internal_do_not_use_render: ({ isFormControl: h }) => /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
          /* @__PURE__ */ y.jsx(
            so,
            {
              ...f,
              ref: t,
              __scopeCheckbox: r
            }
          ),
          h && /* @__PURE__ */ y.jsx(
            fo,
            {
              __scopeCheckbox: r
            }
          )
        ] })
      }
    );
  }
);
Lr.displayName = qt;
var lo = "CheckboxIndicator", co = c.forwardRef(
  (e, t) => {
    const { __scopeCheckbox: r, forceMount: n, ...o } = e, a = zr(lo, r);
    return /* @__PURE__ */ y.jsx(
      Dr,
      {
        present: n || Le(a.checked) || a.checked === !0,
        children: /* @__PURE__ */ y.jsx(
          Q.span,
          {
            "data-state": po(a.checked),
            "data-disabled": a.disabled ? "" : void 0,
            ...o,
            ref: t,
            style: { pointerEvents: "none", ...e.style }
          }
        )
      }
    );
  }
);
co.displayName = lo;
var uo = "CheckboxBubbleInput", fo = c.forwardRef(
  ({ __scopeCheckbox: e, ...t }, r) => {
    const {
      control: n,
      hasConsumerStoppedPropagationRef: o,
      checked: a,
      defaultChecked: i,
      required: s,
      disabled: l,
      name: u,
      value: d,
      form: f,
      bubbleInput: h,
      setBubbleInput: g
    } = zr(uo, e), x = ie(r, g), p = Ir(a), v = Fr(n);
    c.useEffect(() => {
      const b = h;
      if (!b) return;
      const k = window.HTMLInputElement.prototype, $ = Object.getOwnPropertyDescriptor(
        k,
        "checked"
      ).set, S = !o.current;
      if (p !== a && $) {
        const O = new Event("click", { bubbles: S });
        b.indeterminate = Le(a), $.call(b, Le(a) ? !1 : a), b.dispatchEvent(O);
      }
    }, [h, p, a, o]);
    const w = c.useRef(Le(a) ? !1 : a);
    return /* @__PURE__ */ y.jsx(
      Q.input,
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: i ?? w.current,
        required: s,
        disabled: l,
        name: u,
        value: d,
        form: f,
        ...t,
        tabIndex: -1,
        ref: x,
        style: {
          ...t.style,
          ...v,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0,
          // We transform because the input is absolutely positioned but we have
          // rendered it **after** the button. This pulls it back to sit on top
          // of the button.
          transform: "translateX(-100%)"
        }
      }
    );
  }
);
fo.displayName = uo;
function qs(e) {
  return typeof e == "function";
}
function Le(e) {
  return e === "indeterminate";
}
function po(e) {
  return Le(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
const mo = c.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ y.jsx(
  Lr,
  {
    ref: r,
    "data-slot": "checkbox",
    className: ne(
      "peer size-4 shrink-0 rounded-sm border border-[var(--border)]",
      "bg-[var(--background)] transition-colors duration-200",
      "data-[state=checked]:border-[var(--primary)] data-[state=checked]:bg-[var(--primary)] data-[state=checked]:text-[var(--primary-foreground)]",
      "focus-visible:ring-2 focus-visible:ring-[var(--ring)] focus-visible:ring-offset-0",
      "disabled:cursor-not-allowed disabled:opacity-50",
      "aria-invalid:border-[var(--destructive)] aria-invalid:ring-[var(--destructive)]/20",
      "dark:aria-invalid:ring-[var(--destructive)]/40",
      e
    ),
    ...t,
    children: /* @__PURE__ */ y.jsx(
      co,
      {
        "data-slot": "checkbox-indicator",
        className: "flex items-center justify-center text-current",
        children: /* @__PURE__ */ y.jsx(ao, { className: "size-3.5" })
      }
    )
  }
));
mo.displayName = Lr.displayName;
var Us = "Label", ho = c.forwardRef((e, t) => /* @__PURE__ */ y.jsx(
  Q.label,
  {
    ...e,
    ref: t,
    onMouseDown: (r) => {
      var n;
      r.target.closest("button, input, select, textarea") || ((n = e.onMouseDown) == null || n.call(e, r), !r.defaultPrevented && r.detail > 1 && r.preventDefault());
    }
  }
));
ho.displayName = Us;
var vo = ho;
const Ks = se(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
), Xe = c.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ y.jsx(vo, { ref: r, className: ne(Ks(), e), ...t }));
Xe.displayName = vo.displayName;
const Gs = se("flex items-center gap-2", {
  variants: {
    size: {
      default: "",
      sm: "max-w-sm",
      lg: "max-w-lg",
      full: "w-full"
    }
  },
  defaultVariants: {
    size: "default"
  }
}), Ys = se(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
  {
    variants: {
      error: {
        true: "text-[var(--destructive)]",
        false: "text-[var(--foreground)]"
      }
    },
    defaultVariants: {
      error: !1
    }
  }
), Xs = se("text-sm text-[var(--destructive)]", {
  variants: {
    size: {
      default: "",
      sm: "text-xs",
      lg: "text-base",
      full: ""
    }
  },
  defaultVariants: {
    size: "default"
  }
}), go = c.forwardRef(
  ({ className: e, size: t, label: r, error: n, required: o, field: a, fieldControl: i, id: s }, l) => {
    const u = c.useId(), d = s || (a == null ? void 0 : a.fieldId) || u;
    return /* @__PURE__ */ y.jsxs("div", { className: "w-full flex flex-col gap-1.5", children: [
      /* @__PURE__ */ y.jsxs("div", { className: ne(Gs({ size: t, className: e })), children: [
        /* @__PURE__ */ y.jsx(
          mo,
          {
            ...(i == null ? void 0 : i.field) || {},
            ref: l,
            id: d,
            "aria-describedby": n ? `${d}-error` : void 0,
            "aria-invalid": !!n
          }
        ),
        r && /* @__PURE__ */ y.jsxs(
          Xe,
          {
            htmlFor: d,
            className: ne("text-sm font-medium leading-none", Ys({ error: !!n })),
            children: [
              r,
              o && " *"
            ]
          }
        )
      ] }),
      n && /* @__PURE__ */ y.jsx("p", { className: Xs({ size: t }), id: `${d}-error`, children: n })
    ] });
  }
);
go.displayName = "CheckboxField";
const bo = c.forwardRef(
  ({ className: e, type: t, ...r }, n) => /* @__PURE__ */ y.jsx(
    "input",
    {
      type: t,
      className: ne(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-[var(--muted-foreground)] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
        e
      ),
      ref: n,
      ...r
    }
  )
);
bo.displayName = "Input";
const Zs = se("flex flex-col gap-1.5", {
  variants: {
    size: {
      default: "",
      sm: "max-w-sm",
      lg: "max-w-lg",
      full: "w-full"
    }
  },
  defaultVariants: {
    size: "default"
  }
}), Js = se(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
  {
    variants: {
      error: {
        true: "text-[var(--destructive)]",
        false: "text-[var(--foreground)]"
      }
    },
    defaultVariants: {
      error: !1
    }
  }
), Qs = se("text-sm text-[var(--destructive)]", {
  variants: {
    size: {
      default: "",
      sm: "text-xs",
      lg: "text-base",
      full: ""
    }
  },
  defaultVariants: {
    size: "default"
  }
}), yo = c.forwardRef(
  ({ className: e, size: t, label: r, placeholder: n, error: o, required: a, field: i, fieldControl: s, id: l }, u) => {
    const d = c.useId(), f = l || (i == null ? void 0 : i.fieldId) || d;
    return /* @__PURE__ */ y.jsxs("div", { className: "w-full flex flex-col gap-1.5", children: [
      r && /* @__PURE__ */ y.jsxs(Xe, { htmlFor: f, className: Js({ error: !!o }), children: [
        r,
        a && " *"
      ] }),
      /* @__PURE__ */ y.jsx(
        bo,
        {
          ...(s == null ? void 0 : s.field) || {},
          id: f,
          ref: u,
          className: ne(Zs({ size: t, className: e })),
          "aria-describedby": o ? `${f}-error` : void 0,
          "aria-invalid": !!o,
          placeholder: n || ""
        }
      ),
      o && /* @__PURE__ */ y.jsx("p", { className: Qs({ size: t }), id: `${f}-error`, children: o })
    ] });
  }
);
yo.displayName = "TextField";
const xo = c.forwardRef(
  ({ className: e, error: t, resize: r = "vertical", ...n }, o) => {
    const a = {
      none: "resize-none",
      vertical: "resize-y",
      horizontal: "resize-x",
      both: "resize"
    }[r];
    return /* @__PURE__ */ y.jsx("div", { className: "relative w-full", children: /* @__PURE__ */ y.jsx(
      "textarea",
      {
        className: ne(
          "flex min-h-[100px] w-full rounded-md border px-3 py-2 text-sm",
          "bg-[var(--input)] text-[var(--foreground)] placeholder:text-[var(--muted-foreground)]",
          "focus:ring-2 focus:ring-[var(--ring)] focus:ring-offset-0",
          "disabled:opacity-50 disabled:cursor-not-allowed",
          "transition-colors duration-200",
          a,
          t ? "border-[var(--destructive)] ring-1 ring-[var(--destructive)]" : "border-[var(--border)]",
          e
        ),
        ref: o,
        ...n
      }
    ) });
  }
);
xo.displayName = "Textarea";
const el = se("flex flex-col gap-1.5", {
  variants: {
    size: {
      default: "",
      sm: "max-w-sm",
      lg: "max-w-lg",
      full: "w-full"
    }
  },
  defaultVariants: {
    size: "default"
  }
}), tl = se(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
  {
    variants: {
      error: {
        true: "text-[var(--destructive)]",
        false: "text-[var(--foreground)]"
      }
    },
    defaultVariants: {
      error: !1
    }
  }
), rl = se("text-sm text-[var(--destructive)]", {
  variants: {
    size: {
      default: "",
      sm: "text-xs",
      lg: "text-base",
      full: ""
    }
  },
  defaultVariants: {
    size: "default"
  }
}), wo = c.forwardRef(
  ({ className: e, size: t, label: r, placeholder: n, error: o, required: a, field: i, fieldControl: s, id: l }, u) => {
    const d = c.useId(), f = l || (i == null ? void 0 : i.fieldId) || d;
    return /* @__PURE__ */ y.jsxs("div", { className: "w-full flex flex-col gap-1.5", children: [
      r && /* @__PURE__ */ y.jsxs(Xe, { htmlFor: f, className: tl({ error: !!o }), children: [
        r,
        a && " *"
      ] }),
      /* @__PURE__ */ y.jsx(
        xo,
        {
          ...(s == null ? void 0 : s.field) || {},
          id: f,
          ref: u,
          className: ne(el({ size: t, className: e })),
          "aria-describedby": o ? `${f}-error` : void 0,
          "aria-invalid": !!o,
          placeholder: n || ""
        }
      ),
      o && /* @__PURE__ */ y.jsx("p", { className: rl({ size: t }), id: `${f}-error`, children: o })
    ] });
  }
);
wo.displayName = "TextAreaField";
function ko(e) {
  const t = e + "CollectionProvider", [r, n] = et(t), [o, a] = r(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), i = (p) => {
    const { scope: v, children: w } = p, b = Ie.useRef(null), k = Ie.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ y.jsx(o, { scope: v, itemMap: k, collectionRef: b, children: w });
  };
  i.displayName = t;
  const s = e + "CollectionSlot", l = /* @__PURE__ */ yt(s), u = Ie.forwardRef(
    (p, v) => {
      const { scope: w, children: b } = p, k = a(s, w), $ = ie(v, k.collectionRef);
      return /* @__PURE__ */ y.jsx(l, { ref: $, children: b });
    }
  );
  u.displayName = s;
  const d = e + "CollectionItemSlot", f = "data-radix-collection-item", h = /* @__PURE__ */ yt(d), g = Ie.forwardRef(
    (p, v) => {
      const { scope: w, children: b, ...k } = p, $ = Ie.useRef(null), S = ie(v, $), O = a(d, w);
      return Ie.useEffect(() => (O.itemMap.set($, { ref: $, ...k }), () => void O.itemMap.delete($))), /* @__PURE__ */ y.jsx(h, { [f]: "", ref: S, children: b });
    }
  );
  g.displayName = d;
  function x(p) {
    const v = a(e + "CollectionConsumer", p);
    return Ie.useCallback(() => {
      const w = v.collectionRef.current;
      if (!w) return [];
      const b = Array.from(w.querySelectorAll(`[${f}]`));
      return Array.from(v.itemMap.values()).sort(
        (k, $) => b.indexOf(k.ref.current) - b.indexOf($.ref.current)
      );
    }, [v.collectionRef, v.itemMap]);
  }
  return [
    { Provider: i, Slot: u, ItemSlot: g },
    x,
    n
  ];
}
var nl = c.createContext(void 0);
function Vr(e) {
  const t = c.useContext(nl);
  return e || t || "ltr";
}
var ol = c[" useId ".trim().toString()] || (() => {
}), al = 0;
function Ut(e) {
  const [t, r] = c.useState(ol());
  return fe(() => {
    r((n) => n ?? String(al++));
  }, [e]), t ? `radix-${t}` : "";
}
function Ve(e) {
  const t = c.useRef(e);
  return c.useEffect(() => {
    t.current = e;
  }), c.useMemo(() => (...r) => {
    var n;
    return (n = t.current) == null ? void 0 : n.call(t, ...r);
  }, []);
}
var lr = "rovingFocusGroup.onEntryFocus", il = { bubbles: !1, cancelable: !0 }, $t = "RovingFocusGroup", [$r, $o, sl] = ko($t), [ll, Eo] = et(
  $t,
  [sl]
), [cl, ul] = ll($t), Co = c.forwardRef(
  (e, t) => /* @__PURE__ */ y.jsx($r.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ y.jsx($r.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ y.jsx(dl, { ...e, ref: t }) }) })
);
Co.displayName = $t;
var dl = c.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: r,
    orientation: n,
    loop: o = !1,
    dir: a,
    currentTabStopId: i,
    defaultCurrentTabStopId: s,
    onCurrentTabStopIdChange: l,
    onEntryFocus: u,
    preventScrollOnEntryFocus: d = !1,
    ...f
  } = e, h = c.useRef(null), g = ie(t, h), x = Vr(a), [p, v] = xt({
    prop: i,
    defaultProp: s ?? null,
    onChange: l,
    caller: $t
  }), [w, b] = c.useState(!1), k = Ve(u), $ = $o(r), S = c.useRef(!1), [O, N] = c.useState(0);
  return c.useEffect(() => {
    const E = h.current;
    if (E)
      return E.addEventListener(lr, k), () => E.removeEventListener(lr, k);
  }, [k]), /* @__PURE__ */ y.jsx(
    cl,
    {
      scope: r,
      orientation: n,
      dir: x,
      loop: o,
      currentTabStopId: p,
      onItemFocus: c.useCallback(
        (E) => v(E),
        [v]
      ),
      onItemShiftTab: c.useCallback(() => b(!0), []),
      onFocusableItemAdd: c.useCallback(
        () => N((E) => E + 1),
        []
      ),
      onFocusableItemRemove: c.useCallback(
        () => N((E) => E - 1),
        []
      ),
      children: /* @__PURE__ */ y.jsx(
        Q.div,
        {
          tabIndex: w || O === 0 ? -1 : 0,
          "data-orientation": n,
          ...f,
          ref: g,
          style: { outline: "none", ...e.style },
          onMouseDown: J(e.onMouseDown, () => {
            S.current = !0;
          }),
          onFocus: J(e.onFocus, (E) => {
            const F = !S.current;
            if (E.target === E.currentTarget && F && !w) {
              const B = new CustomEvent(lr, il);
              if (E.currentTarget.dispatchEvent(B), !B.defaultPrevented) {
                const U = $().filter((M) => M.focusable), q = U.find((M) => M.active), L = U.find((M) => M.id === p), D = [q, L, ...U].filter(
                  Boolean
                ).map((M) => M.ref.current);
                No(D, d);
              }
            }
            S.current = !1;
          }),
          onBlur: J(e.onBlur, () => b(!1))
        }
      )
    }
  );
}), Ro = "RovingFocusGroupItem", So = c.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: r,
      focusable: n = !0,
      active: o = !1,
      tabStopId: a,
      children: i,
      ...s
    } = e, l = Ut(), u = a || l, d = ul(Ro, r), f = d.currentTabStopId === u, h = $o(r), { onFocusableItemAdd: g, onFocusableItemRemove: x, currentTabStopId: p } = d;
    return c.useEffect(() => {
      if (n)
        return g(), () => x();
    }, [n, g, x]), /* @__PURE__ */ y.jsx(
      $r.ItemSlot,
      {
        scope: r,
        id: u,
        focusable: n,
        active: o,
        children: /* @__PURE__ */ y.jsx(
          Q.span,
          {
            tabIndex: f ? 0 : -1,
            "data-orientation": d.orientation,
            ...s,
            ref: t,
            onMouseDown: J(e.onMouseDown, (v) => {
              n ? d.onItemFocus(u) : v.preventDefault();
            }),
            onFocus: J(e.onFocus, () => d.onItemFocus(u)),
            onKeyDown: J(e.onKeyDown, (v) => {
              if (v.key === "Tab" && v.shiftKey) {
                d.onItemShiftTab();
                return;
              }
              if (v.target !== v.currentTarget) return;
              const w = ml(v, d.orientation, d.dir);
              if (w !== void 0) {
                if (v.metaKey || v.ctrlKey || v.altKey || v.shiftKey) return;
                v.preventDefault();
                let b = h().filter((k) => k.focusable).map((k) => k.ref.current);
                if (w === "last") b.reverse();
                else if (w === "prev" || w === "next") {
                  w === "prev" && b.reverse();
                  const k = b.indexOf(v.currentTarget);
                  b = d.loop ? hl(b, k + 1) : b.slice(k + 1);
                }
                setTimeout(() => No(b));
              }
            }),
            children: typeof i == "function" ? i({ isCurrentTabStop: f, hasTabStop: p != null }) : i
          }
        )
      }
    );
  }
);
So.displayName = Ro;
var fl = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function pl(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function ml(e, t, r) {
  const n = pl(e.key, r);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(n)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(n)))
    return fl[n];
}
function No(e, t = !1) {
  const r = document.activeElement;
  for (const n of e)
    if (n === r || (n.focus({ preventScroll: t }), document.activeElement !== r)) return;
}
function hl(e, t) {
  return e.map((r, n) => e[(t + n) % e.length]);
}
var vl = Co, gl = So;
/**
 * @license lucide-react v0.503.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bl = [["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]], yl = Mr("circle", bl);
var Wr = "Radio", [xl, Po] = et(Wr), [wl, kl] = xl(Wr), To = c.forwardRef(
  (e, t) => {
    const {
      __scopeRadio: r,
      name: n,
      checked: o = !1,
      required: a,
      disabled: i,
      value: s = "on",
      onCheck: l,
      form: u,
      ...d
    } = e, [f, h] = c.useState(null), g = ie(t, (v) => h(v)), x = c.useRef(!1), p = f ? u || !!f.closest("form") : !0;
    return /* @__PURE__ */ y.jsxs(wl, { scope: r, checked: o, disabled: i, children: [
      /* @__PURE__ */ y.jsx(
        Q.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": o,
          "data-state": Ao(o),
          "data-disabled": i ? "" : void 0,
          disabled: i,
          value: s,
          ...d,
          ref: g,
          onClick: J(e.onClick, (v) => {
            o || (l == null || l()), p && (x.current = v.isPropagationStopped(), x.current || v.stopPropagation());
          })
        }
      ),
      p && /* @__PURE__ */ y.jsx(
        Oo,
        {
          control: f,
          bubbles: !x.current,
          name: n,
          value: s,
          checked: o,
          required: a,
          disabled: i,
          form: u,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
To.displayName = Wr;
var jo = "RadioIndicator", _o = c.forwardRef(
  (e, t) => {
    const { __scopeRadio: r, forceMount: n, ...o } = e, a = kl(jo, r);
    return /* @__PURE__ */ y.jsx(Dr, { present: n || a.checked, children: /* @__PURE__ */ y.jsx(
      Q.span,
      {
        "data-state": Ao(a.checked),
        "data-disabled": a.disabled ? "" : void 0,
        ...o,
        ref: t
      }
    ) });
  }
);
_o.displayName = jo;
var $l = "RadioBubbleInput", Oo = c.forwardRef(
  ({
    __scopeRadio: e,
    control: t,
    checked: r,
    bubbles: n = !0,
    ...o
  }, a) => {
    const i = c.useRef(null), s = ie(i, a), l = Ir(r), u = Fr(t);
    return c.useEffect(() => {
      const d = i.current;
      if (!d) return;
      const f = window.HTMLInputElement.prototype, h = Object.getOwnPropertyDescriptor(
        f,
        "checked"
      ).set;
      if (l !== r && h) {
        const g = new Event("click", { bubbles: n });
        h.call(d, r), d.dispatchEvent(g);
      }
    }, [l, r, n]), /* @__PURE__ */ y.jsx(
      Q.input,
      {
        type: "radio",
        "aria-hidden": !0,
        defaultChecked: r,
        ...o,
        tabIndex: -1,
        ref: s,
        style: {
          ...o.style,
          ...u,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
Oo.displayName = $l;
function Ao(e) {
  return e ? "checked" : "unchecked";
}
var El = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], Kt = "RadioGroup", [Cl, ef] = et(Kt, [
  Eo,
  Po
]), Io = Eo(), Fo = Po(), [Rl, Sl] = Cl(Kt), Do = c.forwardRef(
  (e, t) => {
    const {
      __scopeRadioGroup: r,
      name: n,
      defaultValue: o,
      value: a,
      required: i = !1,
      disabled: s = !1,
      orientation: l,
      dir: u,
      loop: d = !0,
      onValueChange: f,
      ...h
    } = e, g = Io(r), x = Vr(u), [p, v] = xt({
      prop: a,
      defaultProp: o ?? null,
      onChange: f,
      caller: Kt
    });
    return /* @__PURE__ */ y.jsx(
      Rl,
      {
        scope: r,
        name: n,
        required: i,
        disabled: s,
        value: p,
        onValueChange: v,
        children: /* @__PURE__ */ y.jsx(
          vl,
          {
            asChild: !0,
            ...g,
            orientation: l,
            dir: x,
            loop: d,
            children: /* @__PURE__ */ y.jsx(
              Q.div,
              {
                role: "radiogroup",
                "aria-required": i,
                "aria-orientation": l,
                "data-disabled": s ? "" : void 0,
                dir: x,
                ...h,
                ref: t
              }
            )
          }
        )
      }
    );
  }
);
Do.displayName = Kt;
var Mo = "RadioGroupItem", zo = c.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: r, disabled: n, ...o } = e, a = Sl(Mo, r), i = a.disabled || n, s = Io(r), l = Fo(r), u = c.useRef(null), d = ie(t, u), f = a.value === o.value, h = c.useRef(!1);
    return c.useEffect(() => {
      const g = (p) => {
        El.includes(p.key) && (h.current = !0);
      }, x = () => h.current = !1;
      return document.addEventListener("keydown", g), document.addEventListener("keyup", x), () => {
        document.removeEventListener("keydown", g), document.removeEventListener("keyup", x);
      };
    }, []), /* @__PURE__ */ y.jsx(
      gl,
      {
        asChild: !0,
        ...s,
        focusable: !i,
        active: f,
        children: /* @__PURE__ */ y.jsx(
          To,
          {
            disabled: i,
            required: a.required,
            checked: f,
            ...l,
            ...o,
            name: a.name,
            ref: d,
            onCheck: () => a.onValueChange(o.value),
            onKeyDown: J((g) => {
              g.key === "Enter" && g.preventDefault();
            }),
            onFocus: J(o.onFocus, () => {
              var g;
              h.current && ((g = u.current) == null || g.click());
            })
          }
        )
      }
    );
  }
);
zo.displayName = Mo;
var Nl = "RadioGroupIndicator", Lo = c.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: r, ...n } = e, o = Fo(r);
    return /* @__PURE__ */ y.jsx(_o, { ...o, ...n, ref: t });
  }
);
Lo.displayName = Nl;
var Vo = Do, Wo = zo, Pl = Lo;
const Bo = c.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ y.jsx(Vo, { className: ne("grid gap-2", e), ref: r, ...t }));
Bo.displayName = Vo.displayName;
const Ho = c.forwardRef(({ className: e, children: t, ...r }, n) => /* @__PURE__ */ y.jsx(
  Wo,
  {
    ref: n,
    className: ne(
      "relative h-4 w-4 rounded-full border border-[var(--border)]",
      "text-[var(--primary)]",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring)]",
      "disabled:cursor-not-allowed disabled:opacity-50",
      "transition-colors duration-200",
      e
    ),
    ...r,
    children: /* @__PURE__ */ y.jsx(Pl, { className: "absolute inset-0 flex items-center justify-center", children: /* @__PURE__ */ y.jsx(yl, { className: "h-2.5 w-2.5 fill-[var(--primary)] text-[var(--primary)]" }) })
  }
));
Ho.displayName = Wo.displayName;
const Tl = se("flex flex-col gap-1.5", {
  variants: {
    size: {
      default: "",
      sm: "max-w-sm",
      lg: "max-w-lg",
      full: "w-full"
    }
  },
  defaultVariants: {
    size: "default"
  }
}), jl = se(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
  {
    variants: {
      error: {
        true: "text-[var(--destructive)]",
        false: "text-[var(--foreground)]"
      }
    },
    defaultVariants: {
      error: !1
    }
  }
), _l = se("text-sm text-[var(--destructive)]", {
  variants: {
    size: {
      default: "",
      sm: "text-xs",
      lg: "text-base",
      full: ""
    }
  },
  defaultVariants: {
    size: "default"
  }
}), qo = c.forwardRef(
  ({ className: e, size: t, label: r, error: n, required: o, field: a, fieldControl: i, id: s, options: l }, u) => {
    const d = c.useId(), f = s || (a == null ? void 0 : a.fieldId) || d;
    return /* @__PURE__ */ y.jsxs("div", { className: "w-full flex flex-col gap-1.5", children: [
      r && /* @__PURE__ */ y.jsxs(Xe, { htmlFor: f, className: jl({ error: !!n }), children: [
        r,
        o && " *"
      ] }),
      /* @__PURE__ */ y.jsx(
        Bo,
        {
          ...(i == null ? void 0 : i.field) || {},
          ref: u,
          className: ne(Tl({ size: t, className: e })),
          "aria-describedby": n ? `${f}-error` : void 0,
          "aria-invalid": !!n,
          children: l.map((h) => /* @__PURE__ */ y.jsxs("div", { className: "flex items-center space-x-2", children: [
            /* @__PURE__ */ y.jsx(Ho, { value: h.value, id: `${f}-${h.value}` }),
            /* @__PURE__ */ y.jsx(Xe, { htmlFor: `${f}-${h.value}`, children: h.label })
          ] }, h.value))
        }
      ),
      n && /* @__PURE__ */ y.jsx("p", { className: _l({ size: t }), id: `${f}-error`, children: n })
    ] });
  }
);
qo.displayName = "RadioField";
function Ol(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = Ve(e);
  c.useEffect(() => {
    const n = (o) => {
      o.key === "Escape" && r(o);
    };
    return t.addEventListener("keydown", n, { capture: !0 }), () => t.removeEventListener("keydown", n, { capture: !0 });
  }, [r, t]);
}
var Al = "DismissableLayer", Er = "dismissableLayer.update", Il = "dismissableLayer.pointerDownOutside", Fl = "dismissableLayer.focusOutside", $n, Uo = c.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Ko = c.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: r = !1,
      onEscapeKeyDown: n,
      onPointerDownOutside: o,
      onFocusOutside: a,
      onInteractOutside: i,
      onDismiss: s,
      ...l
    } = e, u = c.useContext(Uo), [d, f] = c.useState(null), h = (d == null ? void 0 : d.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, g] = c.useState({}), x = ie(t, (N) => f(N)), p = Array.from(u.layers), [v] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), w = p.indexOf(v), b = d ? p.indexOf(d) : -1, k = u.layersWithOutsidePointerEventsDisabled.size > 0, $ = b >= w, S = zl((N) => {
      const E = N.target, F = [...u.branches].some((B) => B.contains(E));
      !$ || F || (o == null || o(N), i == null || i(N), N.defaultPrevented || (s == null || s()));
    }, h), O = Ll((N) => {
      const E = N.target;
      [...u.branches].some((F) => F.contains(E)) || (a == null || a(N), i == null || i(N), N.defaultPrevented || (s == null || s()));
    }, h);
    return Ol((N) => {
      b === u.layers.size - 1 && (n == null || n(N), !N.defaultPrevented && s && (N.preventDefault(), s()));
    }, h), c.useEffect(() => {
      if (d)
        return r && (u.layersWithOutsidePointerEventsDisabled.size === 0 && ($n = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), En(), () => {
          r && u.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = $n);
        };
    }, [d, h, r, u]), c.useEffect(() => () => {
      d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), En());
    }, [d, u]), c.useEffect(() => {
      const N = () => g({});
      return document.addEventListener(Er, N), () => document.removeEventListener(Er, N);
    }, []), /* @__PURE__ */ y.jsx(
      Q.div,
      {
        ...l,
        ref: x,
        style: {
          pointerEvents: k ? $ ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: J(e.onFocusCapture, O.onFocusCapture),
        onBlurCapture: J(e.onBlurCapture, O.onBlurCapture),
        onPointerDownCapture: J(
          e.onPointerDownCapture,
          S.onPointerDownCapture
        )
      }
    );
  }
);
Ko.displayName = Al;
var Dl = "DismissableLayerBranch", Ml = c.forwardRef((e, t) => {
  const r = c.useContext(Uo), n = c.useRef(null), o = ie(t, n);
  return c.useEffect(() => {
    const a = n.current;
    if (a)
      return r.branches.add(a), () => {
        r.branches.delete(a);
      };
  }, [r.branches]), /* @__PURE__ */ y.jsx(Q.div, { ...e, ref: o });
});
Ml.displayName = Dl;
function zl(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = Ve(e), n = c.useRef(!1), o = c.useRef(() => {
  });
  return c.useEffect(() => {
    const a = (s) => {
      if (s.target && !n.current) {
        let l = function() {
          Go(
            Il,
            r,
            u,
            { discrete: !0 }
          );
        };
        const u = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = l, t.addEventListener("click", o.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", o.current);
      n.current = !1;
    }, i = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(i), t.removeEventListener("pointerdown", a), t.removeEventListener("click", o.current);
    };
  }, [t, r]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => n.current = !0
  };
}
function Ll(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = Ve(e), n = c.useRef(!1);
  return c.useEffect(() => {
    const o = (a) => {
      a.target && !n.current && Go(Fl, r, { originalEvent: a }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, r]), {
    onFocusCapture: () => n.current = !0,
    onBlurCapture: () => n.current = !1
  };
}
function En() {
  const e = new CustomEvent(Er);
  document.dispatchEvent(e);
}
function Go(e, t, r, { discrete: n }) {
  const o = r.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: r });
  t && o.addEventListener(e, t, { once: !0 }), n ? Is(o, a) : o.dispatchEvent(a);
}
var Vl = "Portal", Yo = c.forwardRef((e, t) => {
  var s;
  const { container: r, ...n } = e, [o, a] = c.useState(!1);
  fe(() => a(!0), []);
  const i = r || o && ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body);
  return i ? Di.createPortal(/* @__PURE__ */ y.jsx(Q.div, { ...n, ref: t }), i) : null;
});
Yo.displayName = Vl;
var cr = 0;
function Wl() {
  c.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? Cn()), document.body.insertAdjacentElement("beforeend", e[1] ?? Cn()), cr++, () => {
      cr === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), cr--;
    };
  }, []);
}
function Cn() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var ur = "focusScope.autoFocusOnMount", dr = "focusScope.autoFocusOnUnmount", Rn = { bubbles: !1, cancelable: !0 }, Bl = "FocusScope", Xo = c.forwardRef((e, t) => {
  const {
    loop: r = !1,
    trapped: n = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: a,
    ...i
  } = e, [s, l] = c.useState(null), u = Ve(o), d = Ve(a), f = c.useRef(null), h = ie(t, (p) => l(p)), g = c.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  c.useEffect(() => {
    if (n) {
      let p = function(k) {
        if (g.paused || !s) return;
        const $ = k.target;
        s.contains($) ? f.current = $ : ze(f.current, { select: !0 });
      }, v = function(k) {
        if (g.paused || !s) return;
        const $ = k.relatedTarget;
        $ !== null && (s.contains($) || ze(f.current, { select: !0 }));
      }, w = function(k) {
        if (document.activeElement === document.body)
          for (const $ of k)
            $.removedNodes.length > 0 && ze(s);
      };
      document.addEventListener("focusin", p), document.addEventListener("focusout", v);
      const b = new MutationObserver(w);
      return s && b.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", p), document.removeEventListener("focusout", v), b.disconnect();
      };
    }
  }, [n, s, g.paused]), c.useEffect(() => {
    if (s) {
      Nn.add(g);
      const p = document.activeElement;
      if (!s.contains(p)) {
        const v = new CustomEvent(ur, Rn);
        s.addEventListener(ur, u), s.dispatchEvent(v), v.defaultPrevented || (Hl(Yl(Zo(s)), { select: !0 }), document.activeElement === p && ze(s));
      }
      return () => {
        s.removeEventListener(ur, u), setTimeout(() => {
          const v = new CustomEvent(dr, Rn);
          s.addEventListener(dr, d), s.dispatchEvent(v), v.defaultPrevented || ze(p ?? document.body, { select: !0 }), s.removeEventListener(dr, d), Nn.remove(g);
        }, 0);
      };
    }
  }, [s, u, d, g]);
  const x = c.useCallback(
    (p) => {
      if (!r && !n || g.paused) return;
      const v = p.key === "Tab" && !p.altKey && !p.ctrlKey && !p.metaKey, w = document.activeElement;
      if (v && w) {
        const b = p.currentTarget, [k, $] = ql(b);
        k && $ ? !p.shiftKey && w === $ ? (p.preventDefault(), r && ze(k, { select: !0 })) : p.shiftKey && w === k && (p.preventDefault(), r && ze($, { select: !0 })) : w === b && p.preventDefault();
      }
    },
    [r, n, g.paused]
  );
  return /* @__PURE__ */ y.jsx(Q.div, { tabIndex: -1, ...i, ref: h, onKeyDown: x });
});
Xo.displayName = Bl;
function Hl(e, { select: t = !1 } = {}) {
  const r = document.activeElement;
  for (const n of e)
    if (ze(n, { select: t }), document.activeElement !== r) return;
}
function ql(e) {
  const t = Zo(e), r = Sn(t, e), n = Sn(t.reverse(), e);
  return [r, n];
}
function Zo(e) {
  const t = [], r = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => {
      const o = n.tagName === "INPUT" && n.type === "hidden";
      return n.disabled || n.hidden || o ? NodeFilter.FILTER_SKIP : n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; r.nextNode(); ) t.push(r.currentNode);
  return t;
}
function Sn(e, t) {
  for (const r of e)
    if (!Ul(r, { upTo: t })) return r;
}
function Ul(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function Kl(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function ze(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const r = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== r && Kl(e) && t && e.select();
  }
}
var Nn = Gl();
function Gl() {
  let e = [];
  return {
    add(t) {
      const r = e[0];
      t !== r && (r == null || r.pause()), e = Pn(e, t), e.unshift(t);
    },
    remove(t) {
      var r;
      e = Pn(e, t), (r = e[0]) == null || r.resume();
    }
  };
}
function Pn(e, t) {
  const r = [...e], n = r.indexOf(t);
  return n !== -1 && r.splice(n, 1), r;
}
function Yl(e) {
  return e.filter((t) => t.tagName !== "A");
}
var Xl = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, ot = /* @__PURE__ */ new WeakMap(), jt = /* @__PURE__ */ new WeakMap(), _t = {}, fr = 0, Jo = function(e) {
  return e && (e.host || Jo(e.parentNode));
}, Zl = function(e, t) {
  return t.map(function(r) {
    if (e.contains(r))
      return r;
    var n = Jo(r);
    return n && e.contains(n) ? n : (console.error("aria-hidden", r, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(r) {
    return !!r;
  });
}, Jl = function(e, t, r, n) {
  var o = Zl(t, Array.isArray(e) ? e : [e]);
  _t[r] || (_t[r] = /* @__PURE__ */ new WeakMap());
  var a = _t[r], i = [], s = /* @__PURE__ */ new Set(), l = new Set(o), u = function(f) {
    !f || s.has(f) || (s.add(f), u(f.parentNode));
  };
  o.forEach(u);
  var d = function(f) {
    !f || l.has(f) || Array.prototype.forEach.call(f.children, function(h) {
      if (s.has(h))
        d(h);
      else
        try {
          var g = h.getAttribute(n), x = g !== null && g !== "false", p = (ot.get(h) || 0) + 1, v = (a.get(h) || 0) + 1;
          ot.set(h, p), a.set(h, v), i.push(h), p === 1 && x && jt.set(h, !0), v === 1 && h.setAttribute(r, "true"), x || h.setAttribute(n, "true");
        } catch (w) {
          console.error("aria-hidden: cannot operate on ", h, w);
        }
    });
  };
  return d(t), s.clear(), fr++, function() {
    i.forEach(function(f) {
      var h = ot.get(f) - 1, g = a.get(f) - 1;
      ot.set(f, h), a.set(f, g), h || (jt.has(f) || f.removeAttribute(n), jt.delete(f)), g || f.removeAttribute(r);
    }), fr--, fr || (ot = /* @__PURE__ */ new WeakMap(), ot = /* @__PURE__ */ new WeakMap(), jt = /* @__PURE__ */ new WeakMap(), _t = {});
  };
}, Ql = function(e, t, r) {
  r === void 0 && (r = "data-aria-hidden");
  var n = Array.from(Array.isArray(e) ? e : [e]), o = Xl(e);
  return o ? (n.push.apply(n, Array.from(o.querySelectorAll("[aria-live], script"))), Jl(n, o, r, "aria-hidden")) : function() {
    return null;
  };
}, Ne = function() {
  return Ne = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var o in t) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, Ne.apply(this, arguments);
};
function Qo(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
}
function ec(e, t, r) {
  for (var n = 0, o = t.length, a; n < o; n++)
    (a || !(n in t)) && (a || (a = Array.prototype.slice.call(t, 0, n)), a[n] = t[n]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var Ft = "right-scroll-bar-position", Dt = "width-before-scroll-bar", tc = "with-scroll-bars-hidden", rc = "--removed-body-scroll-bar-size";
function pr(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function nc(e, t) {
  var r = yr(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return r.value;
        },
        set current(n) {
          var o = r.value;
          o !== n && (r.value = n, r.callback(n, o));
        }
      }
    };
  })[0];
  return r.callback = t, r.facade;
}
var oc = typeof window < "u" ? c.useLayoutEffect : c.useEffect, Tn = /* @__PURE__ */ new WeakMap();
function ac(e, t) {
  var r = nc(null, function(n) {
    return e.forEach(function(o) {
      return pr(o, n);
    });
  });
  return oc(function() {
    var n = Tn.get(r);
    if (n) {
      var o = new Set(n), a = new Set(e), i = r.current;
      o.forEach(function(s) {
        a.has(s) || pr(s, null);
      }), a.forEach(function(s) {
        o.has(s) || pr(s, i);
      });
    }
    Tn.set(r, e);
  }, [e]), r;
}
function ic(e) {
  return e;
}
function sc(e, t) {
  t === void 0 && (t = ic);
  var r = [], n = !1, o = {
    read: function() {
      if (n)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return r.length ? r[r.length - 1] : e;
    },
    useMedium: function(a) {
      var i = t(a, n);
      return r.push(i), function() {
        r = r.filter(function(s) {
          return s !== i;
        });
      };
    },
    assignSyncMedium: function(a) {
      for (n = !0; r.length; ) {
        var i = r;
        r = [], i.forEach(a);
      }
      r = {
        push: function(s) {
          return a(s);
        },
        filter: function() {
          return r;
        }
      };
    },
    assignMedium: function(a) {
      n = !0;
      var i = [];
      if (r.length) {
        var s = r;
        r = [], s.forEach(a), i = r;
      }
      var l = function() {
        var d = i;
        i = [], d.forEach(a);
      }, u = function() {
        return Promise.resolve().then(l);
      };
      u(), r = {
        push: function(d) {
          i.push(d), u();
        },
        filter: function(d) {
          return i = i.filter(d), r;
        }
      };
    }
  };
  return o;
}
function lc(e) {
  e === void 0 && (e = {});
  var t = sc(null);
  return t.options = Ne({ async: !0, ssr: !1 }, e), t;
}
var ea = function(e) {
  var t = e.sideCar, r = Qo(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var n = t.read();
  if (!n)
    throw new Error("Sidecar medium not found");
  return c.createElement(n, Ne({}, r));
};
ea.isSideCarExport = !0;
function cc(e, t) {
  return e.useMedium(t), ea;
}
var ta = lc(), mr = function() {
}, Gt = c.forwardRef(function(e, t) {
  var r = c.useRef(null), n = c.useState({
    onScrollCapture: mr,
    onWheelCapture: mr,
    onTouchMoveCapture: mr
  }), o = n[0], a = n[1], i = e.forwardProps, s = e.children, l = e.className, u = e.removeScrollBar, d = e.enabled, f = e.shards, h = e.sideCar, g = e.noRelative, x = e.noIsolation, p = e.inert, v = e.allowPinchZoom, w = e.as, b = w === void 0 ? "div" : w, k = e.gapMode, $ = Qo(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), S = h, O = ac([r, t]), N = Ne(Ne({}, $), o);
  return c.createElement(
    c.Fragment,
    null,
    d && c.createElement(S, { sideCar: ta, removeScrollBar: u, shards: f, noRelative: g, noIsolation: x, inert: p, setCallbacks: a, allowPinchZoom: !!v, lockRef: r, gapMode: k }),
    i ? c.cloneElement(c.Children.only(s), Ne(Ne({}, N), { ref: O })) : c.createElement(b, Ne({}, N, { className: l, ref: O }), s)
  );
});
Gt.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Gt.classNames = {
  fullWidth: Dt,
  zeroRight: Ft
};
var uc = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function dc() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = uc();
  return t && e.setAttribute("nonce", t), e;
}
function fc(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function pc(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var mc = function() {
  var e = 0, t = null;
  return {
    add: function(r) {
      e == 0 && (t = dc()) && (fc(t, r), pc(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, hc = function() {
  var e = mc();
  return function(t, r) {
    c.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && r]);
  };
}, ra = function() {
  var e = hc(), t = function(r) {
    var n = r.styles, o = r.dynamic;
    return e(n, o), null;
  };
  return t;
}, vc = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, hr = function(e) {
  return parseInt(e || "", 10) || 0;
}, gc = function(e) {
  var t = window.getComputedStyle(document.body), r = t[e === "padding" ? "paddingLeft" : "marginLeft"], n = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [hr(r), hr(n), hr(o)];
}, bc = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return vc;
  var t = gc(e), r = document.documentElement.clientWidth, n = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, n - r + t[2] - t[0])
  };
}, yc = ra(), st = "data-scroll-locked", xc = function(e, t, r, n) {
  var o = e.left, a = e.top, i = e.right, s = e.gap;
  return r === void 0 && (r = "margin"), `
  .`.concat(tc, ` {
   overflow: hidden `).concat(n, `;
   padding-right: `).concat(s, "px ").concat(n, `;
  }
  body[`).concat(st, `] {
    overflow: hidden `).concat(n, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(n, ";"),
    r === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(a, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(n, `;
    `),
    r === "padding" && "padding-right: ".concat(s, "px ").concat(n, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Ft, ` {
    right: `).concat(s, "px ").concat(n, `;
  }
  
  .`).concat(Dt, ` {
    margin-right: `).concat(s, "px ").concat(n, `;
  }
  
  .`).concat(Ft, " .").concat(Ft, ` {
    right: 0 `).concat(n, `;
  }
  
  .`).concat(Dt, " .").concat(Dt, ` {
    margin-right: 0 `).concat(n, `;
  }
  
  body[`).concat(st, `] {
    `).concat(rc, ": ").concat(s, `px;
  }
`);
}, jn = function() {
  var e = parseInt(document.body.getAttribute(st) || "0", 10);
  return isFinite(e) ? e : 0;
}, wc = function() {
  c.useEffect(function() {
    return document.body.setAttribute(st, (jn() + 1).toString()), function() {
      var e = jn() - 1;
      e <= 0 ? document.body.removeAttribute(st) : document.body.setAttribute(st, e.toString());
    };
  }, []);
}, kc = function(e) {
  var t = e.noRelative, r = e.noImportant, n = e.gapMode, o = n === void 0 ? "margin" : n;
  wc();
  var a = c.useMemo(function() {
    return bc(o);
  }, [o]);
  return c.createElement(yc, { styles: xc(a, !t, o, r ? "" : "!important") });
}, Cr = !1;
if (typeof window < "u")
  try {
    var Ot = Object.defineProperty({}, "passive", {
      get: function() {
        return Cr = !0, !0;
      }
    });
    window.addEventListener("test", Ot, Ot), window.removeEventListener("test", Ot, Ot);
  } catch {
    Cr = !1;
  }
var at = Cr ? { passive: !1 } : !1, $c = function(e) {
  return e.tagName === "TEXTAREA";
}, na = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var r = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    r[t] !== "hidden" && // contains scroll inside self
    !(r.overflowY === r.overflowX && !$c(e) && r[t] === "visible")
  );
}, Ec = function(e) {
  return na(e, "overflowY");
}, Cc = function(e) {
  return na(e, "overflowX");
}, _n = function(e, t) {
  var r = t.ownerDocument, n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var o = oa(e, n);
    if (o) {
      var a = aa(e, n), i = a[1], s = a[2];
      if (i > s)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== r.body);
  return !1;
}, Rc = function(e) {
  var t = e.scrollTop, r = e.scrollHeight, n = e.clientHeight;
  return [
    t,
    r,
    n
  ];
}, Sc = function(e) {
  var t = e.scrollLeft, r = e.scrollWidth, n = e.clientWidth;
  return [
    t,
    r,
    n
  ];
}, oa = function(e, t) {
  return e === "v" ? Ec(t) : Cc(t);
}, aa = function(e, t) {
  return e === "v" ? Rc(t) : Sc(t);
}, Nc = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Pc = function(e, t, r, n, o) {
  var a = Nc(e, window.getComputedStyle(t).direction), i = a * n, s = r.target, l = t.contains(s), u = !1, d = i > 0, f = 0, h = 0;
  do {
    if (!s)
      break;
    var g = aa(e, s), x = g[0], p = g[1], v = g[2], w = p - v - a * x;
    (x || w) && oa(e, s) && (f += w, h += x);
    var b = s.parentNode;
    s = b && b.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? b.host : b;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (t.contains(s) || t === s)
  );
  return (d && Math.abs(f) < 1 || !d && Math.abs(h) < 1) && (u = !0), u;
}, At = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, On = function(e) {
  return [e.deltaX, e.deltaY];
}, An = function(e) {
  return e && "current" in e ? e.current : e;
}, Tc = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, jc = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, _c = 0, it = [];
function Oc(e) {
  var t = c.useRef([]), r = c.useRef([0, 0]), n = c.useRef(), o = c.useState(_c++)[0], a = c.useState(ra)[0], i = c.useRef(e);
  c.useEffect(function() {
    i.current = e;
  }, [e]), c.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var p = ec([e.lockRef.current], (e.shards || []).map(An)).filter(Boolean);
      return p.forEach(function(v) {
        return v.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), p.forEach(function(v) {
          return v.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = c.useCallback(function(p, v) {
    if ("touches" in p && p.touches.length === 2 || p.type === "wheel" && p.ctrlKey)
      return !i.current.allowPinchZoom;
    var w = At(p), b = r.current, k = "deltaX" in p ? p.deltaX : b[0] - w[0], $ = "deltaY" in p ? p.deltaY : b[1] - w[1], S, O = p.target, N = Math.abs(k) > Math.abs($) ? "h" : "v";
    if ("touches" in p && N === "h" && O.type === "range")
      return !1;
    var E = _n(N, O);
    if (!E)
      return !0;
    if (E ? S = N : (S = N === "v" ? "h" : "v", E = _n(N, O)), !E)
      return !1;
    if (!n.current && "changedTouches" in p && (k || $) && (n.current = S), !S)
      return !0;
    var F = n.current || S;
    return Pc(F, v, p, F === "h" ? k : $);
  }, []), l = c.useCallback(function(p) {
    var v = p;
    if (!(!it.length || it[it.length - 1] !== a)) {
      var w = "deltaY" in v ? On(v) : At(v), b = t.current.filter(function(S) {
        return S.name === v.type && (S.target === v.target || v.target === S.shadowParent) && Tc(S.delta, w);
      })[0];
      if (b && b.should) {
        v.cancelable && v.preventDefault();
        return;
      }
      if (!b) {
        var k = (i.current.shards || []).map(An).filter(Boolean).filter(function(S) {
          return S.contains(v.target);
        }), $ = k.length > 0 ? s(v, k[0]) : !i.current.noIsolation;
        $ && v.cancelable && v.preventDefault();
      }
    }
  }, []), u = c.useCallback(function(p, v, w, b) {
    var k = { name: p, delta: v, target: w, should: b, shadowParent: Ac(w) };
    t.current.push(k), setTimeout(function() {
      t.current = t.current.filter(function($) {
        return $ !== k;
      });
    }, 1);
  }, []), d = c.useCallback(function(p) {
    r.current = At(p), n.current = void 0;
  }, []), f = c.useCallback(function(p) {
    u(p.type, On(p), p.target, s(p, e.lockRef.current));
  }, []), h = c.useCallback(function(p) {
    u(p.type, At(p), p.target, s(p, e.lockRef.current));
  }, []);
  c.useEffect(function() {
    return it.push(a), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: h
    }), document.addEventListener("wheel", l, at), document.addEventListener("touchmove", l, at), document.addEventListener("touchstart", d, at), function() {
      it = it.filter(function(p) {
        return p !== a;
      }), document.removeEventListener("wheel", l, at), document.removeEventListener("touchmove", l, at), document.removeEventListener("touchstart", d, at);
    };
  }, []);
  var g = e.removeScrollBar, x = e.inert;
  return c.createElement(
    c.Fragment,
    null,
    x ? c.createElement(a, { styles: jc(o) }) : null,
    g ? c.createElement(kc, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function Ac(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const Ic = cc(ta, Oc);
var ia = c.forwardRef(function(e, t) {
  return c.createElement(Gt, Ne({}, e, { ref: t, sideCar: Ic }));
});
ia.classNames = Gt.classNames;
const Fc = ["top", "right", "bottom", "left"], We = Math.min, ye = Math.max, zt = Math.round, It = Math.floor, Te = (e) => ({
  x: e,
  y: e
}), Dc = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Mc = {
  start: "end",
  end: "start"
};
function Rr(e, t, r) {
  return ye(e, We(t, r));
}
function Fe(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function De(e) {
  return e.split("-")[0];
}
function ft(e) {
  return e.split("-")[1];
}
function Br(e) {
  return e === "x" ? "y" : "x";
}
function Hr(e) {
  return e === "y" ? "height" : "width";
}
function Pe(e) {
  return ["top", "bottom"].includes(De(e)) ? "y" : "x";
}
function qr(e) {
  return Br(Pe(e));
}
function zc(e, t, r) {
  r === void 0 && (r = !1);
  const n = ft(e), o = qr(e), a = Hr(o);
  let i = o === "x" ? n === (r ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (i = Lt(i)), [i, Lt(i)];
}
function Lc(e) {
  const t = Lt(e);
  return [Sr(e), t, Sr(t)];
}
function Sr(e) {
  return e.replace(/start|end/g, (t) => Mc[t]);
}
function Vc(e, t, r) {
  const n = ["left", "right"], o = ["right", "left"], a = ["top", "bottom"], i = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return r ? t ? o : n : t ? n : o;
    case "left":
    case "right":
      return t ? a : i;
    default:
      return [];
  }
}
function Wc(e, t, r, n) {
  const o = ft(e);
  let a = Vc(De(e), r === "start", n);
  return o && (a = a.map((i) => i + "-" + o), t && (a = a.concat(a.map(Sr)))), a;
}
function Lt(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Dc[t]);
}
function Bc(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function sa(e) {
  return typeof e != "number" ? Bc(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Vt(e) {
  const {
    x: t,
    y: r,
    width: n,
    height: o
  } = e;
  return {
    width: n,
    height: o,
    top: r,
    left: t,
    right: t + n,
    bottom: r + o,
    x: t,
    y: r
  };
}
function In(e, t, r) {
  let {
    reference: n,
    floating: o
  } = e;
  const a = Pe(t), i = qr(t), s = Hr(i), l = De(t), u = a === "y", d = n.x + n.width / 2 - o.width / 2, f = n.y + n.height / 2 - o.height / 2, h = n[s] / 2 - o[s] / 2;
  let g;
  switch (l) {
    case "top":
      g = {
        x: d,
        y: n.y - o.height
      };
      break;
    case "bottom":
      g = {
        x: d,
        y: n.y + n.height
      };
      break;
    case "right":
      g = {
        x: n.x + n.width,
        y: f
      };
      break;
    case "left":
      g = {
        x: n.x - o.width,
        y: f
      };
      break;
    default:
      g = {
        x: n.x,
        y: n.y
      };
  }
  switch (ft(t)) {
    case "start":
      g[i] -= h * (r && u ? -1 : 1);
      break;
    case "end":
      g[i] += h * (r && u ? -1 : 1);
      break;
  }
  return g;
}
const Hc = async (e, t, r) => {
  const {
    placement: n = "bottom",
    strategy: o = "absolute",
    middleware: a = [],
    platform: i
  } = r, s = a.filter(Boolean), l = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let u = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: d,
    y: f
  } = In(u, n, l), h = n, g = {}, x = 0;
  for (let p = 0; p < s.length; p++) {
    const {
      name: v,
      fn: w
    } = s[p], {
      x: b,
      y: k,
      data: $,
      reset: S
    } = await w({
      x: d,
      y: f,
      initialPlacement: n,
      placement: h,
      strategy: o,
      middlewareData: g,
      rects: u,
      platform: i,
      elements: {
        reference: e,
        floating: t
      }
    });
    d = b ?? d, f = k ?? f, g = {
      ...g,
      [v]: {
        ...g[v],
        ...$
      }
    }, S && x <= 50 && (x++, typeof S == "object" && (S.placement && (h = S.placement), S.rects && (u = S.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : S.rects), {
      x: d,
      y: f
    } = In(u, h, l)), p = -1);
  }
  return {
    x: d,
    y: f,
    placement: h,
    strategy: o,
    middlewareData: g
  };
};
async function wt(e, t) {
  var r;
  t === void 0 && (t = {});
  const {
    x: n,
    y: o,
    platform: a,
    rects: i,
    elements: s,
    strategy: l
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: f = "floating",
    altBoundary: h = !1,
    padding: g = 0
  } = Fe(t, e), x = sa(g), p = s[h ? f === "floating" ? "reference" : "floating" : f], v = Vt(await a.getClippingRect({
    element: (r = await (a.isElement == null ? void 0 : a.isElement(p))) == null || r ? p : p.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)),
    boundary: u,
    rootBoundary: d,
    strategy: l
  })), w = f === "floating" ? {
    x: n,
    y: o,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, b = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), k = await (a.isElement == null ? void 0 : a.isElement(b)) ? await (a.getScale == null ? void 0 : a.getScale(b)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, $ = Vt(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: w,
    offsetParent: b,
    strategy: l
  }) : w);
  return {
    top: (v.top - $.top + x.top) / k.y,
    bottom: ($.bottom - v.bottom + x.bottom) / k.y,
    left: (v.left - $.left + x.left) / k.x,
    right: ($.right - v.right + x.right) / k.x
  };
}
const qc = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: r,
      y: n,
      placement: o,
      rects: a,
      platform: i,
      elements: s,
      middlewareData: l
    } = t, {
      element: u,
      padding: d = 0
    } = Fe(e, t) || {};
    if (u == null)
      return {};
    const f = sa(d), h = {
      x: r,
      y: n
    }, g = qr(o), x = Hr(g), p = await i.getDimensions(u), v = g === "y", w = v ? "top" : "left", b = v ? "bottom" : "right", k = v ? "clientHeight" : "clientWidth", $ = a.reference[x] + a.reference[g] - h[g] - a.floating[x], S = h[g] - a.reference[g], O = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(u));
    let N = O ? O[k] : 0;
    (!N || !await (i.isElement == null ? void 0 : i.isElement(O))) && (N = s.floating[k] || a.floating[x]);
    const E = $ / 2 - S / 2, F = N / 2 - p[x] / 2 - 1, B = We(f[w], F), U = We(f[b], F), q = B, L = N - p[x] - U, D = N / 2 - p[x] / 2 + E, M = Rr(q, D, L), A = !l.arrow && ft(o) != null && D !== M && a.reference[x] / 2 - (D < q ? B : U) - p[x] / 2 < 0, z = A ? D < q ? D - q : D - L : 0;
    return {
      [g]: h[g] + z,
      data: {
        [g]: M,
        centerOffset: D - M - z,
        ...A && {
          alignmentOffset: z
        }
      },
      reset: A
    };
  }
}), Uc = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var r, n;
      const {
        placement: o,
        middlewareData: a,
        rects: i,
        initialPlacement: s,
        platform: l,
        elements: u
      } = t, {
        mainAxis: d = !0,
        crossAxis: f = !0,
        fallbackPlacements: h,
        fallbackStrategy: g = "bestFit",
        fallbackAxisSideDirection: x = "none",
        flipAlignment: p = !0,
        ...v
      } = Fe(e, t);
      if ((r = a.arrow) != null && r.alignmentOffset)
        return {};
      const w = De(o), b = Pe(s), k = De(s) === s, $ = await (l.isRTL == null ? void 0 : l.isRTL(u.floating)), S = h || (k || !p ? [Lt(s)] : Lc(s)), O = x !== "none";
      !h && O && S.push(...Wc(s, p, x, $));
      const N = [s, ...S], E = await wt(t, v), F = [];
      let B = ((n = a.flip) == null ? void 0 : n.overflows) || [];
      if (d && F.push(E[w]), f) {
        const D = zc(o, i, $);
        F.push(E[D[0]], E[D[1]]);
      }
      if (B = [...B, {
        placement: o,
        overflows: F
      }], !F.every((D) => D <= 0)) {
        var U, q;
        const D = (((U = a.flip) == null ? void 0 : U.index) || 0) + 1, M = N[D];
        if (M && (!(f === "alignment" && b !== Pe(M)) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        B.every((z) => z.overflows[0] > 0 && Pe(z.placement) === b)))
          return {
            data: {
              index: D,
              overflows: B
            },
            reset: {
              placement: M
            }
          };
        let A = (q = B.filter((z) => z.overflows[0] <= 0).sort((z, R) => z.overflows[1] - R.overflows[1])[0]) == null ? void 0 : q.placement;
        if (!A)
          switch (g) {
            case "bestFit": {
              var L;
              const z = (L = B.filter((R) => {
                if (O) {
                  const Y = Pe(R.placement);
                  return Y === b || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  Y === "y";
                }
                return !0;
              }).map((R) => [R.placement, R.overflows.filter((Y) => Y > 0).reduce((Y, ce) => Y + ce, 0)]).sort((R, Y) => R[1] - Y[1])[0]) == null ? void 0 : L[0];
              z && (A = z);
              break;
            }
            case "initialPlacement":
              A = s;
              break;
          }
        if (o !== A)
          return {
            reset: {
              placement: A
            }
          };
      }
      return {};
    }
  };
};
function Fn(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function Dn(e) {
  return Fc.some((t) => e[t] >= 0);
}
const Kc = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: r
      } = t, {
        strategy: n = "referenceHidden",
        ...o
      } = Fe(e, t);
      switch (n) {
        case "referenceHidden": {
          const a = await wt(t, {
            ...o,
            elementContext: "reference"
          }), i = Fn(a, r.reference);
          return {
            data: {
              referenceHiddenOffsets: i,
              referenceHidden: Dn(i)
            }
          };
        }
        case "escaped": {
          const a = await wt(t, {
            ...o,
            altBoundary: !0
          }), i = Fn(a, r.floating);
          return {
            data: {
              escapedOffsets: i,
              escaped: Dn(i)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function Gc(e, t) {
  const {
    placement: r,
    platform: n,
    elements: o
  } = e, a = await (n.isRTL == null ? void 0 : n.isRTL(o.floating)), i = De(r), s = ft(r), l = Pe(r) === "y", u = ["left", "top"].includes(i) ? -1 : 1, d = a && l ? -1 : 1, f = Fe(t, e);
  let {
    mainAxis: h,
    crossAxis: g,
    alignmentAxis: x
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return s && typeof x == "number" && (g = s === "end" ? x * -1 : x), l ? {
    x: g * d,
    y: h * u
  } : {
    x: h * u,
    y: g * d
  };
}
const Yc = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var r, n;
      const {
        x: o,
        y: a,
        placement: i,
        middlewareData: s
      } = t, l = await Gc(t, e);
      return i === ((r = s.offset) == null ? void 0 : r.placement) && (n = s.arrow) != null && n.alignmentOffset ? {} : {
        x: o + l.x,
        y: a + l.y,
        data: {
          ...l,
          placement: i
        }
      };
    }
  };
}, Xc = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: r,
        y: n,
        placement: o
      } = t, {
        mainAxis: a = !0,
        crossAxis: i = !1,
        limiter: s = {
          fn: (v) => {
            let {
              x: w,
              y: b
            } = v;
            return {
              x: w,
              y: b
            };
          }
        },
        ...l
      } = Fe(e, t), u = {
        x: r,
        y: n
      }, d = await wt(t, l), f = Pe(De(o)), h = Br(f);
      let g = u[h], x = u[f];
      if (a) {
        const v = h === "y" ? "top" : "left", w = h === "y" ? "bottom" : "right", b = g + d[v], k = g - d[w];
        g = Rr(b, g, k);
      }
      if (i) {
        const v = f === "y" ? "top" : "left", w = f === "y" ? "bottom" : "right", b = x + d[v], k = x - d[w];
        x = Rr(b, x, k);
      }
      const p = s.fn({
        ...t,
        [h]: g,
        [f]: x
      });
      return {
        ...p,
        data: {
          x: p.x - r,
          y: p.y - n,
          enabled: {
            [h]: a,
            [f]: i
          }
        }
      };
    }
  };
}, Zc = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: r,
        y: n,
        placement: o,
        rects: a,
        middlewareData: i
      } = t, {
        offset: s = 0,
        mainAxis: l = !0,
        crossAxis: u = !0
      } = Fe(e, t), d = {
        x: r,
        y: n
      }, f = Pe(o), h = Br(f);
      let g = d[h], x = d[f];
      const p = Fe(s, t), v = typeof p == "number" ? {
        mainAxis: p,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...p
      };
      if (l) {
        const k = h === "y" ? "height" : "width", $ = a.reference[h] - a.floating[k] + v.mainAxis, S = a.reference[h] + a.reference[k] - v.mainAxis;
        g < $ ? g = $ : g > S && (g = S);
      }
      if (u) {
        var w, b;
        const k = h === "y" ? "width" : "height", $ = ["top", "left"].includes(De(o)), S = a.reference[f] - a.floating[k] + ($ && ((w = i.offset) == null ? void 0 : w[f]) || 0) + ($ ? 0 : v.crossAxis), O = a.reference[f] + a.reference[k] + ($ ? 0 : ((b = i.offset) == null ? void 0 : b[f]) || 0) - ($ ? v.crossAxis : 0);
        x < S ? x = S : x > O && (x = O);
      }
      return {
        [h]: g,
        [f]: x
      };
    }
  };
}, Jc = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var r, n;
      const {
        placement: o,
        rects: a,
        platform: i,
        elements: s
      } = t, {
        apply: l = () => {
        },
        ...u
      } = Fe(e, t), d = await wt(t, u), f = De(o), h = ft(o), g = Pe(o) === "y", {
        width: x,
        height: p
      } = a.floating;
      let v, w;
      f === "top" || f === "bottom" ? (v = f, w = h === (await (i.isRTL == null ? void 0 : i.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (w = f, v = h === "end" ? "top" : "bottom");
      const b = p - d.top - d.bottom, k = x - d.left - d.right, $ = We(p - d[v], b), S = We(x - d[w], k), O = !t.middlewareData.shift;
      let N = $, E = S;
      if ((r = t.middlewareData.shift) != null && r.enabled.x && (E = k), (n = t.middlewareData.shift) != null && n.enabled.y && (N = b), O && !h) {
        const B = ye(d.left, 0), U = ye(d.right, 0), q = ye(d.top, 0), L = ye(d.bottom, 0);
        g ? E = x - 2 * (B !== 0 || U !== 0 ? B + U : ye(d.left, d.right)) : N = p - 2 * (q !== 0 || L !== 0 ? q + L : ye(d.top, d.bottom));
      }
      await l({
        ...t,
        availableWidth: E,
        availableHeight: N
      });
      const F = await i.getDimensions(s.floating);
      return x !== F.width || p !== F.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Yt() {
  return typeof window < "u";
}
function pt(e) {
  return la(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function xe(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function _e(e) {
  var t;
  return (t = (la(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function la(e) {
  return Yt() ? e instanceof Node || e instanceof xe(e).Node : !1;
}
function Ce(e) {
  return Yt() ? e instanceof Element || e instanceof xe(e).Element : !1;
}
function je(e) {
  return Yt() ? e instanceof HTMLElement || e instanceof xe(e).HTMLElement : !1;
}
function Mn(e) {
  return !Yt() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof xe(e).ShadowRoot;
}
function Et(e) {
  const {
    overflow: t,
    overflowX: r,
    overflowY: n,
    display: o
  } = Re(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + n + r) && !["inline", "contents"].includes(o);
}
function Qc(e) {
  return ["table", "td", "th"].includes(pt(e));
}
function Xt(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function Ur(e) {
  const t = Kr(), r = Ce(e) ? Re(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((n) => r[n] ? r[n] !== "none" : !1) || (r.containerType ? r.containerType !== "normal" : !1) || !t && (r.backdropFilter ? r.backdropFilter !== "none" : !1) || !t && (r.filter ? r.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((n) => (r.willChange || "").includes(n)) || ["paint", "layout", "strict", "content"].some((n) => (r.contain || "").includes(n));
}
function eu(e) {
  let t = Be(e);
  for (; je(t) && !ct(t); ) {
    if (Ur(t))
      return t;
    if (Xt(t))
      return null;
    t = Be(t);
  }
  return null;
}
function Kr() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function ct(e) {
  return ["html", "body", "#document"].includes(pt(e));
}
function Re(e) {
  return xe(e).getComputedStyle(e);
}
function Zt(e) {
  return Ce(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Be(e) {
  if (pt(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Mn(e) && e.host || // Fallback.
    _e(e)
  );
  return Mn(t) ? t.host : t;
}
function ca(e) {
  const t = Be(e);
  return ct(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : je(t) && Et(t) ? t : ca(t);
}
function kt(e, t, r) {
  var n;
  t === void 0 && (t = []), r === void 0 && (r = !0);
  const o = ca(e), a = o === ((n = e.ownerDocument) == null ? void 0 : n.body), i = xe(o);
  if (a) {
    const s = Nr(i);
    return t.concat(i, i.visualViewport || [], Et(o) ? o : [], s && r ? kt(s) : []);
  }
  return t.concat(o, kt(o, [], r));
}
function Nr(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function ua(e) {
  const t = Re(e);
  let r = parseFloat(t.width) || 0, n = parseFloat(t.height) || 0;
  const o = je(e), a = o ? e.offsetWidth : r, i = o ? e.offsetHeight : n, s = zt(r) !== a || zt(n) !== i;
  return s && (r = a, n = i), {
    width: r,
    height: n,
    $: s
  };
}
function Gr(e) {
  return Ce(e) ? e : e.contextElement;
}
function lt(e) {
  const t = Gr(e);
  if (!je(t))
    return Te(1);
  const r = t.getBoundingClientRect(), {
    width: n,
    height: o,
    $: a
  } = ua(t);
  let i = (a ? zt(r.width) : r.width) / n, s = (a ? zt(r.height) : r.height) / o;
  return (!i || !Number.isFinite(i)) && (i = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: i,
    y: s
  };
}
const tu = /* @__PURE__ */ Te(0);
function da(e) {
  const t = xe(e);
  return !Kr() || !t.visualViewport ? tu : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function ru(e, t, r) {
  return t === void 0 && (t = !1), !r || t && r !== xe(e) ? !1 : t;
}
function Ze(e, t, r, n) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  const o = e.getBoundingClientRect(), a = Gr(e);
  let i = Te(1);
  t && (n ? Ce(n) && (i = lt(n)) : i = lt(e));
  const s = ru(a, r, n) ? da(a) : Te(0);
  let l = (o.left + s.x) / i.x, u = (o.top + s.y) / i.y, d = o.width / i.x, f = o.height / i.y;
  if (a) {
    const h = xe(a), g = n && Ce(n) ? xe(n) : n;
    let x = h, p = Nr(x);
    for (; p && n && g !== x; ) {
      const v = lt(p), w = p.getBoundingClientRect(), b = Re(p), k = w.left + (p.clientLeft + parseFloat(b.paddingLeft)) * v.x, $ = w.top + (p.clientTop + parseFloat(b.paddingTop)) * v.y;
      l *= v.x, u *= v.y, d *= v.x, f *= v.y, l += k, u += $, x = xe(p), p = Nr(x);
    }
  }
  return Vt({
    width: d,
    height: f,
    x: l,
    y: u
  });
}
function Yr(e, t) {
  const r = Zt(e).scrollLeft;
  return t ? t.left + r : Ze(_e(e)).left + r;
}
function fa(e, t, r) {
  r === void 0 && (r = !1);
  const n = e.getBoundingClientRect(), o = n.left + t.scrollLeft - (r ? 0 : (
    // RTL <body> scrollbar.
    Yr(e, n)
  )), a = n.top + t.scrollTop;
  return {
    x: o,
    y: a
  };
}
function nu(e) {
  let {
    elements: t,
    rect: r,
    offsetParent: n,
    strategy: o
  } = e;
  const a = o === "fixed", i = _e(n), s = t ? Xt(t.floating) : !1;
  if (n === i || s && a)
    return r;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = Te(1);
  const d = Te(0), f = je(n);
  if ((f || !f && !a) && ((pt(n) !== "body" || Et(i)) && (l = Zt(n)), je(n))) {
    const g = Ze(n);
    u = lt(n), d.x = g.x + n.clientLeft, d.y = g.y + n.clientTop;
  }
  const h = i && !f && !a ? fa(i, l, !0) : Te(0);
  return {
    width: r.width * u.x,
    height: r.height * u.y,
    x: r.x * u.x - l.scrollLeft * u.x + d.x + h.x,
    y: r.y * u.y - l.scrollTop * u.y + d.y + h.y
  };
}
function ou(e) {
  return Array.from(e.getClientRects());
}
function au(e) {
  const t = _e(e), r = Zt(e), n = e.ownerDocument.body, o = ye(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), a = ye(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
  let i = -r.scrollLeft + Yr(e);
  const s = -r.scrollTop;
  return Re(n).direction === "rtl" && (i += ye(t.clientWidth, n.clientWidth) - o), {
    width: o,
    height: a,
    x: i,
    y: s
  };
}
function iu(e, t) {
  const r = xe(e), n = _e(e), o = r.visualViewport;
  let a = n.clientWidth, i = n.clientHeight, s = 0, l = 0;
  if (o) {
    a = o.width, i = o.height;
    const u = Kr();
    (!u || u && t === "fixed") && (s = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: a,
    height: i,
    x: s,
    y: l
  };
}
function su(e, t) {
  const r = Ze(e, !0, t === "fixed"), n = r.top + e.clientTop, o = r.left + e.clientLeft, a = je(e) ? lt(e) : Te(1), i = e.clientWidth * a.x, s = e.clientHeight * a.y, l = o * a.x, u = n * a.y;
  return {
    width: i,
    height: s,
    x: l,
    y: u
  };
}
function zn(e, t, r) {
  let n;
  if (t === "viewport")
    n = iu(e, r);
  else if (t === "document")
    n = au(_e(e));
  else if (Ce(t))
    n = su(t, r);
  else {
    const o = da(e);
    n = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return Vt(n);
}
function pa(e, t) {
  const r = Be(e);
  return r === t || !Ce(r) || ct(r) ? !1 : Re(r).position === "fixed" || pa(r, t);
}
function lu(e, t) {
  const r = t.get(e);
  if (r)
    return r;
  let n = kt(e, [], !1).filter((s) => Ce(s) && pt(s) !== "body"), o = null;
  const a = Re(e).position === "fixed";
  let i = a ? Be(e) : e;
  for (; Ce(i) && !ct(i); ) {
    const s = Re(i), l = Ur(i);
    !l && s.position === "fixed" && (o = null), (a ? !l && !o : !l && s.position === "static" && o && ["absolute", "fixed"].includes(o.position) || Et(i) && !l && pa(e, i)) ? n = n.filter((u) => u !== i) : o = s, i = Be(i);
  }
  return t.set(e, n), n;
}
function cu(e) {
  let {
    element: t,
    boundary: r,
    rootBoundary: n,
    strategy: o
  } = e;
  const a = [...r === "clippingAncestors" ? Xt(t) ? [] : lu(t, this._c) : [].concat(r), n], i = a[0], s = a.reduce((l, u) => {
    const d = zn(t, u, o);
    return l.top = ye(d.top, l.top), l.right = We(d.right, l.right), l.bottom = We(d.bottom, l.bottom), l.left = ye(d.left, l.left), l;
  }, zn(t, i, o));
  return {
    width: s.right - s.left,
    height: s.bottom - s.top,
    x: s.left,
    y: s.top
  };
}
function uu(e) {
  const {
    width: t,
    height: r
  } = ua(e);
  return {
    width: t,
    height: r
  };
}
function du(e, t, r) {
  const n = je(t), o = _e(t), a = r === "fixed", i = Ze(e, !0, a, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Te(0);
  function u() {
    l.x = Yr(o);
  }
  if (n || !n && !a)
    if ((pt(t) !== "body" || Et(o)) && (s = Zt(t)), n) {
      const g = Ze(t, !0, a, t);
      l.x = g.x + t.clientLeft, l.y = g.y + t.clientTop;
    } else o && u();
  a && !n && o && u();
  const d = o && !n && !a ? fa(o, s) : Te(0), f = i.left + s.scrollLeft - l.x - d.x, h = i.top + s.scrollTop - l.y - d.y;
  return {
    x: f,
    y: h,
    width: i.width,
    height: i.height
  };
}
function vr(e) {
  return Re(e).position === "static";
}
function Ln(e, t) {
  if (!je(e) || Re(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let r = e.offsetParent;
  return _e(e) === r && (r = r.ownerDocument.body), r;
}
function ma(e, t) {
  const r = xe(e);
  if (Xt(e))
    return r;
  if (!je(e)) {
    let o = Be(e);
    for (; o && !ct(o); ) {
      if (Ce(o) && !vr(o))
        return o;
      o = Be(o);
    }
    return r;
  }
  let n = Ln(e, t);
  for (; n && Qc(n) && vr(n); )
    n = Ln(n, t);
  return n && ct(n) && vr(n) && !Ur(n) ? r : n || eu(e) || r;
}
const fu = async function(e) {
  const t = this.getOffsetParent || ma, r = this.getDimensions, n = await r(e.floating);
  return {
    reference: du(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function pu(e) {
  return Re(e).direction === "rtl";
}
const mu = {
  convertOffsetParentRelativeRectToViewportRelativeRect: nu,
  getDocumentElement: _e,
  getClippingRect: cu,
  getOffsetParent: ma,
  getElementRects: fu,
  getClientRects: ou,
  getDimensions: uu,
  getScale: lt,
  isElement: Ce,
  isRTL: pu
};
function ha(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function hu(e, t) {
  let r = null, n;
  const o = _e(e);
  function a() {
    var s;
    clearTimeout(n), (s = r) == null || s.disconnect(), r = null;
  }
  function i(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), a();
    const u = e.getBoundingClientRect(), {
      left: d,
      top: f,
      width: h,
      height: g
    } = u;
    if (s || t(), !h || !g)
      return;
    const x = It(f), p = It(o.clientWidth - (d + h)), v = It(o.clientHeight - (f + g)), w = It(d), b = {
      rootMargin: -x + "px " + -p + "px " + -v + "px " + -w + "px",
      threshold: ye(0, We(1, l)) || 1
    };
    let k = !0;
    function $(S) {
      const O = S[0].intersectionRatio;
      if (O !== l) {
        if (!k)
          return i();
        O ? i(!1, O) : n = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      O === 1 && !ha(u, e.getBoundingClientRect()) && i(), k = !1;
    }
    try {
      r = new IntersectionObserver($, {
        ...b,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      r = new IntersectionObserver($, b);
    }
    r.observe(e);
  }
  return i(!0), a;
}
function vu(e, t, r, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: a = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = n, u = Gr(e), d = o || a ? [...u ? kt(u) : [], ...kt(t)] : [];
  d.forEach((w) => {
    o && w.addEventListener("scroll", r, {
      passive: !0
    }), a && w.addEventListener("resize", r);
  });
  const f = u && s ? hu(u, r) : null;
  let h = -1, g = null;
  i && (g = new ResizeObserver((w) => {
    let [b] = w;
    b && b.target === u && g && (g.unobserve(t), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      var k;
      (k = g) == null || k.observe(t);
    })), r();
  }), u && !l && g.observe(u), g.observe(t));
  let x, p = l ? Ze(e) : null;
  l && v();
  function v() {
    const w = Ze(e);
    p && !ha(p, w) && r(), p = w, x = requestAnimationFrame(v);
  }
  return r(), () => {
    var w;
    d.forEach((b) => {
      o && b.removeEventListener("scroll", r), a && b.removeEventListener("resize", r);
    }), f == null || f(), (w = g) == null || w.disconnect(), g = null, l && cancelAnimationFrame(x);
  };
}
const gu = Yc, bu = Xc, yu = Uc, xu = Jc, wu = Kc, Vn = qc, ku = Zc, $u = (e, t, r) => {
  const n = /* @__PURE__ */ new Map(), o = {
    platform: mu,
    ...r
  }, a = {
    ...o.platform,
    _c: n
  };
  return Hc(e, t, {
    ...o,
    platform: a
  });
};
var Eu = typeof document < "u", Cu = function() {
}, Mt = Eu ? Ai : Cu;
function Wt(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let r, n, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (r = e.length, r !== t.length) return !1;
      for (n = r; n-- !== 0; )
        if (!Wt(e[n], t[n]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), r = o.length, r !== Object.keys(t).length)
      return !1;
    for (n = r; n-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[n]))
        return !1;
    for (n = r; n-- !== 0; ) {
      const a = o[n];
      if (!(a === "_owner" && e.$$typeof) && !Wt(e[a], t[a]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function va(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Wn(e, t) {
  const r = va(e);
  return Math.round(t * r) / r;
}
function gr(e) {
  const t = c.useRef(e);
  return Mt(() => {
    t.current = e;
  }), t;
}
function Ru(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: r = "absolute",
    middleware: n = [],
    platform: o,
    elements: {
      reference: a,
      floating: i
    } = {},
    transform: s = !0,
    whileElementsMounted: l,
    open: u
  } = e, [d, f] = c.useState({
    x: 0,
    y: 0,
    strategy: r,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [h, g] = c.useState(n);
  Wt(h, n) || g(n);
  const [x, p] = c.useState(null), [v, w] = c.useState(null), b = c.useCallback((R) => {
    R !== O.current && (O.current = R, p(R));
  }, []), k = c.useCallback((R) => {
    R !== N.current && (N.current = R, w(R));
  }, []), $ = a || x, S = i || v, O = c.useRef(null), N = c.useRef(null), E = c.useRef(d), F = l != null, B = gr(l), U = gr(o), q = gr(u), L = c.useCallback(() => {
    if (!O.current || !N.current)
      return;
    const R = {
      placement: t,
      strategy: r,
      middleware: h
    };
    U.current && (R.platform = U.current), $u(O.current, N.current, R).then((Y) => {
      const ce = {
        ...Y,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: q.current !== !1
      };
      D.current && !Wt(E.current, ce) && (E.current = ce, Ht.flushSync(() => {
        f(ce);
      }));
    });
  }, [h, t, r, U, q]);
  Mt(() => {
    u === !1 && E.current.isPositioned && (E.current.isPositioned = !1, f((R) => ({
      ...R,
      isPositioned: !1
    })));
  }, [u]);
  const D = c.useRef(!1);
  Mt(() => (D.current = !0, () => {
    D.current = !1;
  }), []), Mt(() => {
    if ($ && (O.current = $), S && (N.current = S), $ && S) {
      if (B.current)
        return B.current($, S, L);
      L();
    }
  }, [$, S, L, B, F]);
  const M = c.useMemo(() => ({
    reference: O,
    floating: N,
    setReference: b,
    setFloating: k
  }), [b, k]), A = c.useMemo(() => ({
    reference: $,
    floating: S
  }), [$, S]), z = c.useMemo(() => {
    const R = {
      position: r,
      left: 0,
      top: 0
    };
    if (!A.floating)
      return R;
    const Y = Wn(A.floating, d.x), ce = Wn(A.floating, d.y);
    return s ? {
      ...R,
      transform: "translate(" + Y + "px, " + ce + "px)",
      ...va(A.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: r,
      left: Y,
      top: ce
    };
  }, [r, s, A.floating, d.x, d.y]);
  return c.useMemo(() => ({
    ...d,
    update: L,
    refs: M,
    elements: A,
    floatingStyles: z
  }), [d, L, M, A, z]);
}
const Su = (e) => {
  function t(r) {
    return {}.hasOwnProperty.call(r, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(r) {
      const {
        element: n,
        padding: o
      } = typeof e == "function" ? e(r) : e;
      return n && t(n) ? n.current != null ? Vn({
        element: n.current,
        padding: o
      }).fn(r) : {} : n ? Vn({
        element: n,
        padding: o
      }).fn(r) : {};
    }
  };
}, Nu = (e, t) => ({
  ...gu(e),
  options: [e, t]
}), Pu = (e, t) => ({
  ...bu(e),
  options: [e, t]
}), Tu = (e, t) => ({
  ...ku(e),
  options: [e, t]
}), ju = (e, t) => ({
  ...yu(e),
  options: [e, t]
}), _u = (e, t) => ({
  ...xu(e),
  options: [e, t]
}), Ou = (e, t) => ({
  ...wu(e),
  options: [e, t]
}), Au = (e, t) => ({
  ...Su(e),
  options: [e, t]
});
var Iu = "Arrow", ga = c.forwardRef((e, t) => {
  const { children: r, width: n = 10, height: o = 5, ...a } = e;
  return /* @__PURE__ */ y.jsx(
    Q.svg,
    {
      ...a,
      ref: t,
      width: n,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? r : /* @__PURE__ */ y.jsx("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
ga.displayName = Iu;
var Fu = ga, Xr = "Popper", [ba, ya] = et(Xr), [Du, xa] = ba(Xr), wa = (e) => {
  const { __scopePopper: t, children: r } = e, [n, o] = c.useState(null);
  return /* @__PURE__ */ y.jsx(Du, { scope: t, anchor: n, onAnchorChange: o, children: r });
};
wa.displayName = Xr;
var ka = "PopperAnchor", $a = c.forwardRef(
  (e, t) => {
    const { __scopePopper: r, virtualRef: n, ...o } = e, a = xa(ka, r), i = c.useRef(null), s = ie(t, i);
    return c.useEffect(() => {
      a.onAnchorChange((n == null ? void 0 : n.current) || i.current);
    }), n ? null : /* @__PURE__ */ y.jsx(Q.div, { ...o, ref: s });
  }
);
$a.displayName = ka;
var Zr = "PopperContent", [Mu, zu] = ba(Zr), Ea = c.forwardRef(
  (e, t) => {
    var T, G, X, V, ee, Z;
    const {
      __scopePopper: r,
      side: n = "bottom",
      sideOffset: o = 0,
      align: a = "center",
      alignOffset: i = 0,
      arrowPadding: s = 0,
      avoidCollisions: l = !0,
      collisionBoundary: u = [],
      collisionPadding: d = 0,
      sticky: f = "partial",
      hideWhenDetached: h = !1,
      updatePositionStrategy: g = "optimized",
      onPlaced: x,
      ...p
    } = e, v = xa(Zr, r), [w, b] = c.useState(null), k = ie(t, (me) => b(me)), [$, S] = c.useState(null), O = Fr($), N = (O == null ? void 0 : O.width) ?? 0, E = (O == null ? void 0 : O.height) ?? 0, F = n + (a !== "center" ? "-" + a : ""), B = typeof d == "number" ? d : { top: 0, right: 0, bottom: 0, left: 0, ...d }, U = Array.isArray(u) ? u : [u], q = U.length > 0, L = {
      padding: B,
      boundary: U.filter(Vu),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: q
    }, { refs: D, floatingStyles: M, placement: A, isPositioned: z, middlewareData: R } = Ru({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: F,
      whileElementsMounted: (...me) => vu(...me, {
        animationFrame: g === "always"
      }),
      elements: {
        reference: v.anchor
      },
      middleware: [
        Nu({ mainAxis: o + E, alignmentAxis: i }),
        l && Pu({
          mainAxis: !0,
          crossAxis: !1,
          limiter: f === "partial" ? Tu() : void 0,
          ...L
        }),
        l && ju({ ...L }),
        _u({
          ...L,
          apply: ({ elements: me, rects: Ue, availableWidth: Se, availableHeight: $e }) => {
            const { width: Ct, height: Rt } = Ue.reference, Oe = me.floating.style;
            Oe.setProperty("--radix-popper-available-width", `${Se}px`), Oe.setProperty("--radix-popper-available-height", `${$e}px`), Oe.setProperty("--radix-popper-anchor-width", `${Ct}px`), Oe.setProperty("--radix-popper-anchor-height", `${Rt}px`);
          }
        }),
        $ && Au({ element: $, padding: s }),
        Wu({ arrowWidth: N, arrowHeight: E }),
        h && Ou({ strategy: "referenceHidden", ...L })
      ]
    }), [Y, ce] = Sa(A), pe = Ve(x);
    fe(() => {
      z && (pe == null || pe());
    }, [z, pe]);
    const we = (T = R.arrow) == null ? void 0 : T.x, oe = (G = R.arrow) == null ? void 0 : G.y, ae = ((X = R.arrow) == null ? void 0 : X.centerOffset) !== 0, [be, ve] = c.useState();
    return fe(() => {
      w && ve(window.getComputedStyle(w).zIndex);
    }, [w]), /* @__PURE__ */ y.jsx(
      "div",
      {
        ref: D.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...M,
          transform: z ? M.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: be,
          "--radix-popper-transform-origin": [
            (V = R.transformOrigin) == null ? void 0 : V.x,
            (ee = R.transformOrigin) == null ? void 0 : ee.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((Z = R.hide) == null ? void 0 : Z.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ y.jsx(
          Mu,
          {
            scope: r,
            placedSide: Y,
            onArrowChange: S,
            arrowX: we,
            arrowY: oe,
            shouldHideArrow: ae,
            children: /* @__PURE__ */ y.jsx(
              Q.div,
              {
                "data-side": Y,
                "data-align": ce,
                ...p,
                ref: k,
                style: {
                  ...p.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: z ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
Ea.displayName = Zr;
var Ca = "PopperArrow", Lu = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, Ra = c.forwardRef(function(e, t) {
  const { __scopePopper: r, ...n } = e, o = zu(Ca, r), a = Lu[o.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ y.jsx(
      "span",
      {
        ref: o.onArrowChange,
        style: {
          position: "absolute",
          left: o.arrowX,
          top: o.arrowY,
          [a]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[o.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[o.placedSide],
          visibility: o.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ y.jsx(
          Fu,
          {
            ...n,
            ref: t,
            style: {
              ...n.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
Ra.displayName = Ca;
function Vu(e) {
  return e !== null;
}
var Wu = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var p, v, w;
    const { placement: r, rects: n, middlewareData: o } = t, a = ((p = o.arrow) == null ? void 0 : p.centerOffset) !== 0, i = a ? 0 : e.arrowWidth, s = a ? 0 : e.arrowHeight, [l, u] = Sa(r), d = { start: "0%", center: "50%", end: "100%" }[u], f = (((v = o.arrow) == null ? void 0 : v.x) ?? 0) + i / 2, h = (((w = o.arrow) == null ? void 0 : w.y) ?? 0) + s / 2;
    let g = "", x = "";
    return l === "bottom" ? (g = a ? d : `${f}px`, x = `${-s}px`) : l === "top" ? (g = a ? d : `${f}px`, x = `${n.floating.height + s}px`) : l === "right" ? (g = `${-s}px`, x = a ? d : `${h}px`) : l === "left" && (g = `${n.floating.width + s}px`, x = a ? d : `${h}px`), { data: { x: g, y: x } };
  }
});
function Sa(e) {
  const [t, r = "center"] = e.split("-");
  return [t, r];
}
var Bu = wa, Hu = $a, qu = Ea, Uu = Ra, Na = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), Ku = "VisuallyHidden", Gu = c.forwardRef(
  (e, t) => /* @__PURE__ */ y.jsx(
    Q.span,
    {
      ...e,
      ref: t,
      style: { ...Na, ...e.style }
    }
  )
);
Gu.displayName = Ku;
/**
 * @license lucide-react v0.503.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yu = [["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]], Xu = Mr("chevron-down", Yu);
function Bn(e, [t, r]) {
  return Math.min(r, Math.max(t, e));
}
var Zu = [" ", "Enter", "ArrowUp", "ArrowDown"], Ju = [" ", "Enter"], Je = "Select", [Jt, Qt, Qu] = ko(Je), [mt, tf] = et(Je, [
  Qu,
  ya
]), er = ya(), [ed, He] = mt(Je), [td, rd] = mt(Je), Pa = (e) => {
  const {
    __scopeSelect: t,
    children: r,
    open: n,
    defaultOpen: o,
    onOpenChange: a,
    value: i,
    defaultValue: s,
    onValueChange: l,
    dir: u,
    name: d,
    autoComplete: f,
    disabled: h,
    required: g,
    form: x
  } = e, p = er(t), [v, w] = c.useState(null), [b, k] = c.useState(null), [$, S] = c.useState(!1), O = Vr(u), [N, E] = xt({
    prop: n,
    defaultProp: o ?? !1,
    onChange: a,
    caller: Je
  }), [F, B] = xt({
    prop: i,
    defaultProp: s,
    onChange: l,
    caller: Je
  }), U = c.useRef(null), q = v ? x || !!v.closest("form") : !0, [L, D] = c.useState(/* @__PURE__ */ new Set()), M = Array.from(L).map((A) => A.props.value).join(";");
  return /* @__PURE__ */ y.jsx(Bu, { ...p, children: /* @__PURE__ */ y.jsxs(
    ed,
    {
      required: g,
      scope: t,
      trigger: v,
      onTriggerChange: w,
      valueNode: b,
      onValueNodeChange: k,
      valueNodeHasChildren: $,
      onValueNodeHasChildrenChange: S,
      contentId: Ut(),
      value: F,
      onValueChange: B,
      open: N,
      onOpenChange: E,
      dir: O,
      triggerPointerDownPosRef: U,
      disabled: h,
      children: [
        /* @__PURE__ */ y.jsx(Jt.Provider, { scope: t, children: /* @__PURE__ */ y.jsx(
          td,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: c.useCallback((A) => {
              D((z) => new Set(z).add(A));
            }, []),
            onNativeOptionRemove: c.useCallback((A) => {
              D((z) => {
                const R = new Set(z);
                return R.delete(A), R;
              });
            }, []),
            children: r
          }
        ) }),
        q ? /* @__PURE__ */ y.jsxs(
          Xa,
          {
            "aria-hidden": !0,
            required: g,
            tabIndex: -1,
            name: d,
            autoComplete: f,
            value: F,
            onChange: (A) => B(A.target.value),
            disabled: h,
            form: x,
            children: [
              F === void 0 ? /* @__PURE__ */ y.jsx("option", { value: "" }) : null,
              Array.from(L)
            ]
          },
          M
        ) : null
      ]
    }
  ) });
};
Pa.displayName = Je;
var Ta = "SelectTrigger", ja = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, disabled: n = !1, ...o } = e, a = er(r), i = He(Ta, r), s = i.disabled || n, l = ie(t, i.onTriggerChange), u = Qt(r), d = c.useRef("touch"), [f, h, g] = Ja((p) => {
      const v = u().filter((k) => !k.disabled), w = v.find((k) => k.value === i.value), b = Qa(v, p, w);
      b !== void 0 && i.onValueChange(b.value);
    }), x = (p) => {
      s || (i.onOpenChange(!0), g()), p && (i.triggerPointerDownPosRef.current = {
        x: Math.round(p.pageX),
        y: Math.round(p.pageY)
      });
    };
    return /* @__PURE__ */ y.jsx(Hu, { asChild: !0, ...a, children: /* @__PURE__ */ y.jsx(
      Q.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": i.contentId,
        "aria-expanded": i.open,
        "aria-required": i.required,
        "aria-autocomplete": "none",
        dir: i.dir,
        "data-state": i.open ? "open" : "closed",
        disabled: s,
        "data-disabled": s ? "" : void 0,
        "data-placeholder": Za(i.value) ? "" : void 0,
        ...o,
        ref: l,
        onClick: J(o.onClick, (p) => {
          p.currentTarget.focus(), d.current !== "mouse" && x(p);
        }),
        onPointerDown: J(o.onPointerDown, (p) => {
          d.current = p.pointerType;
          const v = p.target;
          v.hasPointerCapture(p.pointerId) && v.releasePointerCapture(p.pointerId), p.button === 0 && p.ctrlKey === !1 && p.pointerType === "mouse" && (x(p), p.preventDefault());
        }),
        onKeyDown: J(o.onKeyDown, (p) => {
          const v = f.current !== "";
          !(p.ctrlKey || p.altKey || p.metaKey) && p.key.length === 1 && h(p.key), !(v && p.key === " ") && Zu.includes(p.key) && (x(), p.preventDefault());
        })
      }
    ) });
  }
);
ja.displayName = Ta;
var _a = "SelectValue", Oa = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, className: n, style: o, children: a, placeholder: i = "", ...s } = e, l = He(_a, r), { onValueNodeHasChildrenChange: u } = l, d = a !== void 0, f = ie(t, l.onValueNodeChange);
    return fe(() => {
      u(d);
    }, [u, d]), /* @__PURE__ */ y.jsx(
      Q.span,
      {
        ...s,
        ref: f,
        style: { pointerEvents: "none" },
        children: Za(l.value) ? /* @__PURE__ */ y.jsx(y.Fragment, { children: i }) : a
      }
    );
  }
);
Oa.displayName = _a;
var nd = "SelectIcon", od = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, children: n, ...o } = e;
    return /* @__PURE__ */ y.jsx(Q.span, { "aria-hidden": !0, ...o, ref: t, children: n || "▼" });
  }
);
od.displayName = nd;
var ad = "SelectPortal", Aa = (e) => /* @__PURE__ */ y.jsx(Yo, { asChild: !0, ...e });
Aa.displayName = ad;
var Qe = "SelectContent", Ia = c.forwardRef(
  (e, t) => {
    const r = He(Qe, e.__scopeSelect), [n, o] = c.useState();
    if (fe(() => {
      o(new DocumentFragment());
    }, []), !r.open) {
      const a = n;
      return a ? Ht.createPortal(
        /* @__PURE__ */ y.jsx(Fa, { scope: e.__scopeSelect, children: /* @__PURE__ */ y.jsx(Jt.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ y.jsx("div", { children: e.children }) }) }),
        a
      ) : null;
    }
    return /* @__PURE__ */ y.jsx(Da, { ...e, ref: t });
  }
);
Ia.displayName = Qe;
var Ee = 10, [Fa, qe] = mt(Qe), id = "SelectContentImpl", sd = /* @__PURE__ */ yt("SelectContent.RemoveScroll"), Da = c.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: r,
      position: n = "item-aligned",
      onCloseAutoFocus: o,
      onEscapeKeyDown: a,
      onPointerDownOutside: i,
      //
      // PopperContent props
      side: s,
      sideOffset: l,
      align: u,
      alignOffset: d,
      arrowPadding: f,
      collisionBoundary: h,
      collisionPadding: g,
      sticky: x,
      hideWhenDetached: p,
      avoidCollisions: v,
      //
      ...w
    } = e, b = He(Qe, r), [k, $] = c.useState(null), [S, O] = c.useState(null), N = ie(t, (T) => $(T)), [E, F] = c.useState(null), [B, U] = c.useState(
      null
    ), q = Qt(r), [L, D] = c.useState(!1), M = c.useRef(!1);
    c.useEffect(() => {
      if (k) return Ql(k);
    }, [k]), Wl();
    const A = c.useCallback(
      (T) => {
        const [G, ...X] = q().map((Z) => Z.ref.current), [V] = X.slice(-1), ee = document.activeElement;
        for (const Z of T)
          if (Z === ee || (Z == null || Z.scrollIntoView({ block: "nearest" }), Z === G && S && (S.scrollTop = 0), Z === V && S && (S.scrollTop = S.scrollHeight), Z == null || Z.focus(), document.activeElement !== ee)) return;
      },
      [q, S]
    ), z = c.useCallback(
      () => A([E, k]),
      [A, E, k]
    );
    c.useEffect(() => {
      L && z();
    }, [L, z]);
    const { onOpenChange: R, triggerPointerDownPosRef: Y } = b;
    c.useEffect(() => {
      if (k) {
        let T = { x: 0, y: 0 };
        const G = (V) => {
          var ee, Z;
          T = {
            x: Math.abs(Math.round(V.pageX) - (((ee = Y.current) == null ? void 0 : ee.x) ?? 0)),
            y: Math.abs(Math.round(V.pageY) - (((Z = Y.current) == null ? void 0 : Z.y) ?? 0))
          };
        }, X = (V) => {
          T.x <= 10 && T.y <= 10 ? V.preventDefault() : k.contains(V.target) || R(!1), document.removeEventListener("pointermove", G), Y.current = null;
        };
        return Y.current !== null && (document.addEventListener("pointermove", G), document.addEventListener("pointerup", X, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", G), document.removeEventListener("pointerup", X, { capture: !0 });
        };
      }
    }, [k, R, Y]), c.useEffect(() => {
      const T = () => R(!1);
      return window.addEventListener("blur", T), window.addEventListener("resize", T), () => {
        window.removeEventListener("blur", T), window.removeEventListener("resize", T);
      };
    }, [R]);
    const [ce, pe] = Ja((T) => {
      const G = q().filter((ee) => !ee.disabled), X = G.find((ee) => ee.ref.current === document.activeElement), V = Qa(G, T, X);
      V && setTimeout(() => V.ref.current.focus());
    }), we = c.useCallback(
      (T, G, X) => {
        const V = !M.current && !X;
        (b.value !== void 0 && b.value === G || V) && (F(T), V && (M.current = !0));
      },
      [b.value]
    ), oe = c.useCallback(() => k == null ? void 0 : k.focus(), [k]), ae = c.useCallback(
      (T, G, X) => {
        const V = !M.current && !X;
        (b.value !== void 0 && b.value === G || V) && U(T);
      },
      [b.value]
    ), be = n === "popper" ? Pr : Ma, ve = be === Pr ? {
      side: s,
      sideOffset: l,
      align: u,
      alignOffset: d,
      arrowPadding: f,
      collisionBoundary: h,
      collisionPadding: g,
      sticky: x,
      hideWhenDetached: p,
      avoidCollisions: v
    } : {};
    return /* @__PURE__ */ y.jsx(
      Fa,
      {
        scope: r,
        content: k,
        viewport: S,
        onViewportChange: O,
        itemRefCallback: we,
        selectedItem: E,
        onItemLeave: oe,
        itemTextRefCallback: ae,
        focusSelectedItem: z,
        selectedItemText: B,
        position: n,
        isPositioned: L,
        searchRef: ce,
        children: /* @__PURE__ */ y.jsx(ia, { as: sd, allowPinchZoom: !0, children: /* @__PURE__ */ y.jsx(
          Xo,
          {
            asChild: !0,
            trapped: b.open,
            onMountAutoFocus: (T) => {
              T.preventDefault();
            },
            onUnmountAutoFocus: J(o, (T) => {
              var G;
              (G = b.trigger) == null || G.focus({ preventScroll: !0 }), T.preventDefault();
            }),
            children: /* @__PURE__ */ y.jsx(
              Ko,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: a,
                onPointerDownOutside: i,
                onFocusOutside: (T) => T.preventDefault(),
                onDismiss: () => b.onOpenChange(!1),
                children: /* @__PURE__ */ y.jsx(
                  be,
                  {
                    role: "listbox",
                    id: b.contentId,
                    "data-state": b.open ? "open" : "closed",
                    dir: b.dir,
                    onContextMenu: (T) => T.preventDefault(),
                    ...w,
                    ...ve,
                    onPlaced: () => D(!0),
                    ref: N,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...w.style
                    },
                    onKeyDown: J(w.onKeyDown, (T) => {
                      const G = T.ctrlKey || T.altKey || T.metaKey;
                      if (T.key === "Tab" && T.preventDefault(), !G && T.key.length === 1 && pe(T.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(T.key)) {
                        let X = q().filter((V) => !V.disabled).map((V) => V.ref.current);
                        if (["ArrowUp", "End"].includes(T.key) && (X = X.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(T.key)) {
                          const V = T.target, ee = X.indexOf(V);
                          X = X.slice(ee + 1);
                        }
                        setTimeout(() => A(X)), T.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Da.displayName = id;
var ld = "SelectItemAlignedPosition", Ma = c.forwardRef((e, t) => {
  const { __scopeSelect: r, onPlaced: n, ...o } = e, a = He(Qe, r), i = qe(Qe, r), [s, l] = c.useState(null), [u, d] = c.useState(null), f = ie(t, (N) => d(N)), h = Qt(r), g = c.useRef(!1), x = c.useRef(!0), { viewport: p, selectedItem: v, selectedItemText: w, focusSelectedItem: b } = i, k = c.useCallback(() => {
    if (a.trigger && a.valueNode && s && u && p && v && w) {
      const N = a.trigger.getBoundingClientRect(), E = u.getBoundingClientRect(), F = a.valueNode.getBoundingClientRect(), B = w.getBoundingClientRect();
      if (a.dir !== "rtl") {
        const V = B.left - E.left, ee = F.left - V, Z = N.left - ee, me = N.width + Z, Ue = Math.max(me, E.width), Se = window.innerWidth - Ee, $e = Bn(ee, [
          Ee,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(Ee, Se - Ue)
        ]);
        s.style.minWidth = me + "px", s.style.left = $e + "px";
      } else {
        const V = E.right - B.right, ee = window.innerWidth - F.right - V, Z = window.innerWidth - N.right - ee, me = N.width + Z, Ue = Math.max(me, E.width), Se = window.innerWidth - Ee, $e = Bn(ee, [
          Ee,
          Math.max(Ee, Se - Ue)
        ]);
        s.style.minWidth = me + "px", s.style.right = $e + "px";
      }
      const U = h(), q = window.innerHeight - Ee * 2, L = p.scrollHeight, D = window.getComputedStyle(u), M = parseInt(D.borderTopWidth, 10), A = parseInt(D.paddingTop, 10), z = parseInt(D.borderBottomWidth, 10), R = parseInt(D.paddingBottom, 10), Y = M + A + L + R + z, ce = Math.min(v.offsetHeight * 5, Y), pe = window.getComputedStyle(p), we = parseInt(pe.paddingTop, 10), oe = parseInt(pe.paddingBottom, 10), ae = N.top + N.height / 2 - Ee, be = q - ae, ve = v.offsetHeight / 2, T = v.offsetTop + ve, G = M + A + T, X = Y - G;
      if (G <= ae) {
        const V = U.length > 0 && v === U[U.length - 1].ref.current;
        s.style.bottom = "0px";
        const ee = u.clientHeight - p.offsetTop - p.offsetHeight, Z = Math.max(
          be,
          ve + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (V ? oe : 0) + ee + z
        ), me = G + Z;
        s.style.height = me + "px";
      } else {
        const V = U.length > 0 && v === U[0].ref.current;
        s.style.top = "0px";
        const ee = Math.max(
          ae,
          M + p.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (V ? we : 0) + ve
        ) + X;
        s.style.height = ee + "px", p.scrollTop = G - ae + p.offsetTop;
      }
      s.style.margin = `${Ee}px 0`, s.style.minHeight = ce + "px", s.style.maxHeight = q + "px", n == null || n(), requestAnimationFrame(() => g.current = !0);
    }
  }, [
    h,
    a.trigger,
    a.valueNode,
    s,
    u,
    p,
    v,
    w,
    a.dir,
    n
  ]);
  fe(() => k(), [k]);
  const [$, S] = c.useState();
  fe(() => {
    u && S(window.getComputedStyle(u).zIndex);
  }, [u]);
  const O = c.useCallback(
    (N) => {
      N && x.current === !0 && (k(), b == null || b(), x.current = !1);
    },
    [k, b]
  );
  return /* @__PURE__ */ y.jsx(
    ud,
    {
      scope: r,
      contentWrapper: s,
      shouldExpandOnScrollRef: g,
      onScrollButtonChange: O,
      children: /* @__PURE__ */ y.jsx(
        "div",
        {
          ref: l,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: $
          },
          children: /* @__PURE__ */ y.jsx(
            Q.div,
            {
              ...o,
              ref: f,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...o.style
              }
            }
          )
        }
      )
    }
  );
});
Ma.displayName = ld;
var cd = "SelectPopperPosition", Pr = c.forwardRef((e, t) => {
  const {
    __scopeSelect: r,
    align: n = "start",
    collisionPadding: o = Ee,
    ...a
  } = e, i = er(r);
  return /* @__PURE__ */ y.jsx(
    qu,
    {
      ...i,
      ...a,
      ref: t,
      align: n,
      collisionPadding: o,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...a.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Pr.displayName = cd;
var [ud, Jr] = mt(Qe, {}), Tr = "SelectViewport", za = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, nonce: n, ...o } = e, a = qe(Tr, r), i = Jr(Tr, r), s = ie(t, a.onViewportChange), l = c.useRef(0);
    return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
      /* @__PURE__ */ y.jsx(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: n
        }
      ),
      /* @__PURE__ */ y.jsx(Jt.Slot, { scope: r, children: /* @__PURE__ */ y.jsx(
        Q.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...o,
          ref: s,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...o.style
          },
          onScroll: J(o.onScroll, (u) => {
            const d = u.currentTarget, { contentWrapper: f, shouldExpandOnScrollRef: h } = i;
            if (h != null && h.current && f) {
              const g = Math.abs(l.current - d.scrollTop);
              if (g > 0) {
                const x = window.innerHeight - Ee * 2, p = parseFloat(f.style.minHeight), v = parseFloat(f.style.height), w = Math.max(p, v);
                if (w < x) {
                  const b = w + g, k = Math.min(x, b), $ = b - k;
                  f.style.height = k + "px", f.style.bottom === "0px" && (d.scrollTop = $ > 0 ? $ : 0, f.style.justifyContent = "flex-end");
                }
              }
            }
            l.current = d.scrollTop;
          })
        }
      ) })
    ] });
  }
);
za.displayName = Tr;
var La = "SelectGroup", [dd, fd] = mt(La), pd = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, ...n } = e, o = Ut();
    return /* @__PURE__ */ y.jsx(dd, { scope: r, id: o, children: /* @__PURE__ */ y.jsx(Q.div, { role: "group", "aria-labelledby": o, ...n, ref: t }) });
  }
);
pd.displayName = La;
var Va = "SelectLabel", Wa = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, ...n } = e, o = fd(Va, r);
    return /* @__PURE__ */ y.jsx(Q.div, { id: o.id, ...n, ref: t });
  }
);
Wa.displayName = Va;
var Bt = "SelectItem", [md, Ba] = mt(Bt), Ha = c.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: r,
      value: n,
      disabled: o = !1,
      textValue: a,
      ...i
    } = e, s = He(Bt, r), l = qe(Bt, r), u = s.value === n, [d, f] = c.useState(a ?? ""), [h, g] = c.useState(!1), x = ie(
      t,
      (b) => {
        var k;
        return (k = l.itemRefCallback) == null ? void 0 : k.call(l, b, n, o);
      }
    ), p = Ut(), v = c.useRef("touch"), w = () => {
      o || (s.onValueChange(n), s.onOpenChange(!1));
    };
    if (n === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ y.jsx(
      md,
      {
        scope: r,
        value: n,
        disabled: o,
        textId: p,
        isSelected: u,
        onItemTextChange: c.useCallback((b) => {
          f((k) => k || ((b == null ? void 0 : b.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ y.jsx(
          Jt.ItemSlot,
          {
            scope: r,
            value: n,
            disabled: o,
            textValue: d,
            children: /* @__PURE__ */ y.jsx(
              Q.div,
              {
                role: "option",
                "aria-labelledby": p,
                "data-highlighted": h ? "" : void 0,
                "aria-selected": u && h,
                "data-state": u ? "checked" : "unchecked",
                "aria-disabled": o || void 0,
                "data-disabled": o ? "" : void 0,
                tabIndex: o ? void 0 : -1,
                ...i,
                ref: x,
                onFocus: J(i.onFocus, () => g(!0)),
                onBlur: J(i.onBlur, () => g(!1)),
                onClick: J(i.onClick, () => {
                  v.current !== "mouse" && w();
                }),
                onPointerUp: J(i.onPointerUp, () => {
                  v.current === "mouse" && w();
                }),
                onPointerDown: J(i.onPointerDown, (b) => {
                  v.current = b.pointerType;
                }),
                onPointerMove: J(i.onPointerMove, (b) => {
                  var k;
                  v.current = b.pointerType, o ? (k = l.onItemLeave) == null || k.call(l) : v.current === "mouse" && b.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: J(i.onPointerLeave, (b) => {
                  var k;
                  b.currentTarget === document.activeElement && ((k = l.onItemLeave) == null || k.call(l));
                }),
                onKeyDown: J(i.onKeyDown, (b) => {
                  var k;
                  ((k = l.searchRef) == null ? void 0 : k.current) !== "" && b.key === " " || (Ju.includes(b.key) && w(), b.key === " " && b.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
Ha.displayName = Bt;
var bt = "SelectItemText", qa = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, className: n, style: o, ...a } = e, i = He(bt, r), s = qe(bt, r), l = Ba(bt, r), u = rd(bt, r), [d, f] = c.useState(null), h = ie(
      t,
      (w) => f(w),
      l.onItemTextChange,
      (w) => {
        var b;
        return (b = s.itemTextRefCallback) == null ? void 0 : b.call(s, w, l.value, l.disabled);
      }
    ), g = d == null ? void 0 : d.textContent, x = c.useMemo(
      () => /* @__PURE__ */ y.jsx("option", { value: l.value, disabled: l.disabled, children: g }, l.value),
      [l.disabled, l.value, g]
    ), { onNativeOptionAdd: p, onNativeOptionRemove: v } = u;
    return fe(() => (p(x), () => v(x)), [p, v, x]), /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
      /* @__PURE__ */ y.jsx(Q.span, { id: l.textId, ...a, ref: h }),
      l.isSelected && i.valueNode && !i.valueNodeHasChildren ? Ht.createPortal(a.children, i.valueNode) : null
    ] });
  }
);
qa.displayName = bt;
var Ua = "SelectItemIndicator", Ka = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, ...n } = e;
    return Ba(Ua, r).isSelected ? /* @__PURE__ */ y.jsx(Q.span, { "aria-hidden": !0, ...n, ref: t }) : null;
  }
);
Ka.displayName = Ua;
var jr = "SelectScrollUpButton", hd = c.forwardRef((e, t) => {
  const r = qe(jr, e.__scopeSelect), n = Jr(jr, e.__scopeSelect), [o, a] = c.useState(!1), i = ie(t, n.onScrollButtonChange);
  return fe(() => {
    if (r.viewport && r.isPositioned) {
      let s = function() {
        const u = l.scrollTop > 0;
        a(u);
      };
      const l = r.viewport;
      return s(), l.addEventListener("scroll", s), () => l.removeEventListener("scroll", s);
    }
  }, [r.viewport, r.isPositioned]), o ? /* @__PURE__ */ y.jsx(
    Ga,
    {
      ...e,
      ref: i,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: l } = r;
        s && l && (s.scrollTop = s.scrollTop - l.offsetHeight);
      }
    }
  ) : null;
});
hd.displayName = jr;
var _r = "SelectScrollDownButton", vd = c.forwardRef((e, t) => {
  const r = qe(_r, e.__scopeSelect), n = Jr(_r, e.__scopeSelect), [o, a] = c.useState(!1), i = ie(t, n.onScrollButtonChange);
  return fe(() => {
    if (r.viewport && r.isPositioned) {
      let s = function() {
        const u = l.scrollHeight - l.clientHeight, d = Math.ceil(l.scrollTop) < u;
        a(d);
      };
      const l = r.viewport;
      return s(), l.addEventListener("scroll", s), () => l.removeEventListener("scroll", s);
    }
  }, [r.viewport, r.isPositioned]), o ? /* @__PURE__ */ y.jsx(
    Ga,
    {
      ...e,
      ref: i,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: l } = r;
        s && l && (s.scrollTop = s.scrollTop + l.offsetHeight);
      }
    }
  ) : null;
});
vd.displayName = _r;
var Ga = c.forwardRef((e, t) => {
  const { __scopeSelect: r, onAutoScroll: n, ...o } = e, a = qe("SelectScrollButton", r), i = c.useRef(null), s = Qt(r), l = c.useCallback(() => {
    i.current !== null && (window.clearInterval(i.current), i.current = null);
  }, []);
  return c.useEffect(() => () => l(), [l]), fe(() => {
    var u, d;
    (d = (u = s().find((f) => f.ref.current === document.activeElement)) == null ? void 0 : u.ref.current) == null || d.scrollIntoView({ block: "nearest" });
  }, [s]), /* @__PURE__ */ y.jsx(
    Q.div,
    {
      "aria-hidden": !0,
      ...o,
      ref: t,
      style: { flexShrink: 0, ...o.style },
      onPointerDown: J(o.onPointerDown, () => {
        i.current === null && (i.current = window.setInterval(n, 50));
      }),
      onPointerMove: J(o.onPointerMove, () => {
        var u;
        (u = a.onItemLeave) == null || u.call(a), i.current === null && (i.current = window.setInterval(n, 50));
      }),
      onPointerLeave: J(o.onPointerLeave, () => {
        l();
      })
    }
  );
}), gd = "SelectSeparator", Ya = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, ...n } = e;
    return /* @__PURE__ */ y.jsx(Q.div, { "aria-hidden": !0, ...n, ref: t });
  }
);
Ya.displayName = gd;
var Or = "SelectArrow", bd = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, ...n } = e, o = er(r), a = He(Or, r), i = qe(Or, r);
    return a.open && i.position === "popper" ? /* @__PURE__ */ y.jsx(Uu, { ...o, ...n, ref: t }) : null;
  }
);
bd.displayName = Or;
var yd = "SelectBubbleInput", Xa = c.forwardRef(
  ({ __scopeSelect: e, value: t, ...r }, n) => {
    const o = c.useRef(null), a = ie(n, o), i = Ir(t);
    return c.useEffect(() => {
      const s = o.current;
      if (!s) return;
      const l = window.HTMLSelectElement.prototype, u = Object.getOwnPropertyDescriptor(
        l,
        "value"
      ).set;
      if (i !== t && u) {
        const d = new Event("change", { bubbles: !0 });
        u.call(s, t), s.dispatchEvent(d);
      }
    }, [i, t]), /* @__PURE__ */ y.jsx(
      Q.select,
      {
        ...r,
        style: { ...Na, ...r.style },
        ref: a,
        defaultValue: t
      }
    );
  }
);
Xa.displayName = yd;
function Za(e) {
  return e === "" || e === void 0;
}
function Ja(e) {
  const t = Ve(e), r = c.useRef(""), n = c.useRef(0), o = c.useCallback(
    (i) => {
      const s = r.current + i;
      t(s), function l(u) {
        r.current = u, window.clearTimeout(n.current), u !== "" && (n.current = window.setTimeout(() => l(""), 1e3));
      }(s);
    },
    [t]
  ), a = c.useCallback(() => {
    r.current = "", window.clearTimeout(n.current);
  }, []);
  return c.useEffect(() => () => window.clearTimeout(n.current), []), [r, o, a];
}
function Qa(e, t, r) {
  const n = t.length > 1 && Array.from(t).every((s) => s === t[0]) ? t[0] : t, o = r ? e.indexOf(r) : -1;
  let a = xd(e, Math.max(o, 0));
  n.length === 1 && (a = a.filter((s) => s !== r));
  const i = a.find(
    (s) => s.textValue.toLowerCase().startsWith(n.toLowerCase())
  );
  return i !== r ? i : void 0;
}
function xd(e, t) {
  return e.map((r, n) => e[(t + n) % e.length]);
}
var wd = Pa, ei = ja, kd = Oa, $d = Aa, ti = Ia, Ed = za, ri = Wa, ni = Ha, Cd = qa, Rd = Ka, oi = Ya;
const Sd = wd, Nd = kd, ai = c.forwardRef(({ className: e, children: t, ...r }, n) => /* @__PURE__ */ y.jsxs(
  ei,
  {
    ref: n,
    className: ne(
      "flex h-10 w-full items-center justify-between rounded-sm px-3 py-2 text-sm",
      "bg-[var(--input)] text-[var(--foreground)] placeholder:text-[var(--muted-foreground)]",
      "border border-[var(--border)]",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring)]",
      "disabled:cursor-not-allowed disabled:opacity-50",
      "transition-colors duration-200",
      e
    ),
    ...r,
    children: [
      t,
      /* @__PURE__ */ y.jsx(Xu, { className: "h-4 w-4 opacity-70" })
    ]
  }
));
ai.displayName = ei.displayName;
const ii = c.forwardRef(({ className: e, children: t, position: r = "popper", ...n }, o) => /* @__PURE__ */ y.jsx($d, { children: /* @__PURE__ */ y.jsx(
  ti,
  {
    ref: o,
    className: ne(
      "relative z-50 min-w-[8rem] overflow-hidden rounded-sm shadow-md",
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0",
      "data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
      "data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2",
      "data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      "bg-[var(--popover)] text-[var(--popover-foreground)]",
      "border border-[var(--border)]",
      r === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
      e
    ),
    position: r,
    ...n,
    children: /* @__PURE__ */ y.jsx(
      Ed,
      {
        className: ne(
          "p-1",
          r === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"
        ),
        children: t
      }
    )
  }
) }));
ii.displayName = ti.displayName;
const Pd = c.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ y.jsx(
  ri,
  {
    ref: r,
    className: ne("px-2 py-1.5 text-sm font-semibold", e),
    ...t
  }
));
Pd.displayName = ri.displayName;
const si = c.forwardRef(({ className: e, children: t, ...r }, n) => /* @__PURE__ */ y.jsxs(
  ni,
  {
    ref: n,
    className: ne(
      "relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none",
      "focus:bg-[var(--accent)] focus:text-[var(--accent-foreground)]",
      "data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      "transition-colors duration-200",
      e
    ),
    ...r,
    children: [
      /* @__PURE__ */ y.jsx("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ y.jsx(Rd, { children: /* @__PURE__ */ y.jsx(ao, { className: "h-4 w-4" }) }) }),
      /* @__PURE__ */ y.jsx(Cd, { children: t })
    ]
  }
));
si.displayName = ni.displayName;
const Td = c.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ y.jsx(
  oi,
  {
    ref: r,
    className: ne("h-px -mx-1 my-1 bg-[var(--muted-foreground)]/20", e),
    ...t
  }
));
Td.displayName = oi.displayName;
const jd = se("flex flex-col gap-1.5", {
  variants: {
    size: {
      default: "",
      sm: "max-w-sm",
      lg: "max-w-lg",
      full: "w-full"
    }
  },
  defaultVariants: {
    size: "default"
  }
}), _d = se(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
  {
    variants: {
      error: {
        true: "text-[var(--destructive)]",
        false: "text-[var(--foreground)]"
      }
    },
    defaultVariants: {
      error: !1
    }
  }
), Od = se("text-sm text-[var(--destructive)]", {
  variants: {
    size: {
      default: "",
      sm: "text-xs",
      lg: "text-base",
      full: ""
    }
  },
  defaultVariants: {
    size: "default"
  }
}), li = c.forwardRef(
  ({ className: e, size: t, label: r, error: n, required: o, field: a, fieldControl: i, id: s, options: l }, u) => {
    const d = c.useId(), f = s || (a == null ? void 0 : a.fieldId) || d;
    return /* @__PURE__ */ y.jsxs("div", { className: "w-full flex flex-col gap-1.5", children: [
      r && /* @__PURE__ */ y.jsxs(Xe, { htmlFor: f, className: _d({ error: !!n }), children: [
        r,
        o && " *"
      ] }),
      /* @__PURE__ */ y.jsxs(Sd, { ...(i == null ? void 0 : i.field) || {}, children: [
        /* @__PURE__ */ y.jsx(
          ai,
          {
            ref: u,
            id: f,
            className: ne(jd({ size: t, className: e })),
            "aria-describedby": n ? `${f}-error` : void 0,
            "aria-invalid": !!n,
            children: /* @__PURE__ */ y.jsx(Nd, { placeholder: "Select an option" })
          }
        ),
        /* @__PURE__ */ y.jsx(ii, { children: l.map((h) => /* @__PURE__ */ y.jsx(si, { value: h.value, children: h.label }, h.value)) })
      ] }),
      n && /* @__PURE__ */ y.jsx("p", { className: Od({ size: t }), id: `${f}-error`, children: n })
    ] });
  }
);
li.displayName = "SelectField";
const Ad = se(
  "grid gap-4 w-full rounded-lg min-h-[100px] border border-[var(--border)] bg-[var(--card)] text-[var(--card-foreground)] shadow-sm transition-colors duration-200",
  {
    variants: {
      size: {
        default: "p-4",
        sm: "p-3",
        lg: "p-6"
      },
      variant: {
        default: "",
        secondary: "bg-[var(--secondary)] text-[var(--secondary-foreground)]",
        ghost: "border-none shadow-none bg-transparent"
      }
    },
    defaultVariants: {
      size: "default",
      variant: "default"
    }
  }
), Id = se(
  "font-semibold leading-none tracking-tight text-[var(--card-foreground)]",
  {
    variants: {
      size: {
        default: "text-xl",
        sm: "text-lg",
        lg: "text-2xl"
      }
    },
    defaultVariants: {
      size: "default"
    }
  }
), Fd = se("text-[var(--muted-foreground)]", {
  variants: {
    size: {
      default: "text-sm mt-2",
      sm: "text-xs mt-1.5",
      lg: "text-base mt-3"
    }
  },
  defaultVariants: {
    size: "default"
  }
}), ci = c.forwardRef(
  ({ className: e, children: t, label: r, description: n, size: o, variant: a }, i) => /* @__PURE__ */ y.jsxs(
    "div",
    {
      ref: i,
      className: ne(
        Ad({ size: o, variant: a }),
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring)]",
        e
      ),
      children: [
        r && /* @__PURE__ */ y.jsx("h2", { className: ne(Id({ size: o }), "mb-2 text-foreground"), children: r }),
        n && /* @__PURE__ */ y.jsx("p", { className: ne(Fd({ size: o }), "mb-4"), children: n }),
        t
      ]
    }
  )
);
ci.displayName = "Container";
const Dd = se(
  "w-full rounded-lg bg-[var(--card)] text-[var(--card-foreground)] min-h-[100px]",
  {
    variants: {
      layout: {
        default: "p-2",
        row: "flex flex-row gap-4",
        column: "flex flex-col gap-4"
      },
      variant: {
        default: "bg-[var(--background)] border border-[var(--border)]",
        ghost: "border-none bg-transparent"
      }
    },
    defaultVariants: {
      layout: "default",
      variant: "default"
    }
  }
), Md = se("font-medium leading-none tracking-tight text-[var(--foreground)]", {
  variants: {
    size: {
      default: "text-lg",
      sm: "text-base",
      lg: "text-xl"
    }
  },
  defaultVariants: {
    size: "default"
  }
}), zd = se("text-[var(--muted-foreground)]", {
  variants: {
    size: {
      default: "text-sm mt-2",
      sm: "text-xs mt-1.5",
      lg: "text-base mt-2.5"
    }
  },
  defaultVariants: {
    size: "default"
  }
}), Ld = "w-full", ui = c.forwardRef(
  ({ className: e, children: t, label: r, description: n, layout: o = "default", variant: a, size: i = "default" }, s) => {
    console.log("Section: ", { variant: a });
    const l = Dd({ layout: o, variant: a }), u = l.includes("flex-row"), d = () => u ? c.Children.map(
      t,
      (f) => c.isValidElement(f) && typeof f.type == "string" ? c.cloneElement(f, {
        className: ne(
          typeof f.props.className == "string" ? f.props.className : void 0,
          "flex-1"
        )
      }) : f
    ) : t;
    return /* @__PURE__ */ y.jsxs("div", { ref: s, className: ne(Ld, e), children: [
      /* @__PURE__ */ y.jsxs("div", { className: "flex flex-col gap-4", children: [
        r && /* @__PURE__ */ y.jsx("h3", { className: ne(Md({ size: i }), "mb-2"), children: r }),
        n && /* @__PURE__ */ y.jsx("p", { className: ne(zd({ size: i }), "mb-4"), children: n })
      ] }),
      /* @__PURE__ */ y.jsx("div", { className: l, children: u ? d() : t })
    ] });
  }
);
ui.displayName = "Section";
const Vd = se(
  "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "bg-[var(--background)] text-[var(--primary)] border-2 border-[var(--primary)] shadow-md hover:bg-[var(--primary)] hover:text-[var(--primary-foreground)]",
        destructive: "bg-[var(--background)] text-[var(--destructive)] border-2 border-[var(--destructive)] shadow-md hover:bg-[var(--destructive)] hover:text-[var(--destructive-foreground)]",
        outline: "border-2 border-[var(--input)] bg-[var(--background)] shadow-sm hover:bg-[var(--accent)] hover:text-[var(--accent-foreground)]",
        secondary: "bg-[var(--background)] text-[var(--secondary)] border-2 border-[var(--secondary)] shadow-md hover:bg-[var(--secondary)] hover:text-[var(--secondary-foreground)]",
        ghost: "hover:bg-[var(--accent)] hover:text-[var(--accent-foreground)] border border-transparent",
        link: "text-[var(--primary)] underline-offset-4 hover:underline"
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-md px-3",
        lg: "h-11 rounded-md px-8",
        icon: "h-10 w-10"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), di = c.forwardRef(
  ({ className: e, variant: t, size: r, asChild: n = !1, ...o }, a) => /* @__PURE__ */ y.jsx(n ? ws : "button", { className: ne(Vd({ variant: t, size: r, className: e })), ref: a, ...o })
);
di.displayName = "Button";
const Wd = "dynamic-form-demo-container", Bd = "dynamic_form_demo_container", Hd = "container", qd = { label: "Employee Onboarding Form" }, Ud = [{ fieldId: "step1-section", fieldName: "step1Section", componentType: "container", componentProps: { label: "Step 1: Basic Details" }, conditionalRules: [{ if: [{ "==": [{ valueFromContext: "step" }, 1] }, { actions: [{ onField: "step1Section", setComponentProps: { is_visible: !0 } }] }, { actions: [{ onField: "step1Section", setComponentProps: { is_visible: !1 } }] }] }], childFields: [{ fieldId: "first-name", fieldName: "firstName", componentType: "text-field", componentProps: { label: "First Name", placeholder: "Enter first name" }, validationRules: [{ ruleType: "required", ruleValue: !0, errorMessage: "First name is required" }] }, { fieldId: "last-name", fieldName: "lastName", componentType: "text-field", componentProps: { label: "Last Name", placeholder: "Enter last name" }, validationRules: [{ ruleType: "required", ruleValue: !0, errorMessage: "Last name is required" }] }, { fieldId: "email", fieldName: "email", componentType: "text-field", componentProps: { label: "Email Address", placeholder: "Enter email address" }, validationRules: [{ ruleType: "required", ruleValue: !0, errorMessage: "Email is required" }, { ruleType: "pattern", ruleValue: "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$", errorMessage: "Invalid email address" }] }, { fieldId: "phone", fieldName: "phone", componentType: "text-field", componentProps: { label: "Phone Number", placeholder: "Enter 10-digit phone number", type: "number" }, validationRules: [{ ruleType: "required", ruleValue: !0, errorMessage: "Phone number is required" }, { ruleType: "pattern", ruleValue: "^\\d{10}$", errorMessage: "Enter a valid 10-digit phone number" }] }, { fieldId: "dob", fieldName: "dob", componentType: "date-field", componentProps: { label: "Date of Birth", placeholder: "Select date of birth", disabledFutureDate: !0 } }, { fieldId: "gender", fieldName: "gender", componentType: "select-field", componentProps: { label: "Gender", options: [{ label: "Male", value: "male" }, { label: "Female", value: "female" }, { label: "Other", value: "other" }] } }] }, { fieldId: "step2section", fieldName: "step2section", componentType: "container", componentProps: { label: "Address Details" }, conditionalRules: [{ if: [{ "==": [{ valueFromContext: "step" }, 2] }, { actions: [{ onField: "step2section", setComponentProps: { is_visible: !0 } }] }, { actions: [{ onField: "step2section", setComponentProps: { is_visible: !1 } }] }] }], childFields: [{ fieldId: "country", fieldName: "country", componentType: "select-field", componentProps: { label: "Country", options: [{ label: "USA", value: "usa" }, { label: "Canada", value: "canada" }, { label: "Other", value: "other" }] } }, { fieldId: "state", fieldName: "state", componentType: "text-field", componentProps: { label: "State", placeholder: "Enter state" }, conditionalRules: [{ if: [{ "==": [{ valueOfField: ["country"] }, "usa"] }, { actions: [{ onField: "state", setComponentProps: { disabled: !1 } }] }, { actions: [{ onField: "state", setComponentProps: { disabled: !0 } }] }] }] }, { fieldId: "city", fieldName: "city", componentType: "text-field", componentProps: { label: "City", placeholder: "Enter city" } }, { fieldId: "zip-code", fieldName: "zipCode", componentType: "text-field", componentProps: { label: "Zip Code", placeholder: "Enter zip code" } }] }, { fieldId: "step3section", fieldName: "step3section", componentType: "container", componentProps: { label: "Occupation Details" }, conditionalRules: [{ if: [{ "==": [{ valueFromContext: "step" }, 3] }, { actions: [{ onField: "step3section", setComponentProps: { is_visible: !0 } }] }, { actions: [{ onField: "step3section", setComponentProps: { is_visible: !1 } }] }] }], childFields: [{ fieldId: "occupation", fieldName: "occupation", componentType: "select-field", componentProps: { label: "Occupation", options: [{ label: "Student", value: "student" }, { label: "Engineer", value: "engineer" }, { label: "Other", value: "other" }] } }, { fieldId: "occupation-other", fieldName: "occupationOther", componentType: "text-field", componentProps: { label: "Please specify", placeholder: "Enter your occupation" }, conditionalRules: [{ if: [{ "==": [{ valueOfField: ["occupation"] }, "other"] }, { actions: [{ onField: "occupationOther", setComponentProps: { is_visible: !0 } }] }, { actions: [{ onField: "occupationOther", setComponentProps: { is_visible: !1 } }] }] }] }] }, { fieldId: "step4section", fieldName: "step4section", componentType: "container", componentProps: { label: "Referral Details" }, conditionalRules: [{ if: [{ "==": [{ valueFromContext: "step" }, 4] }, { actions: [{ onField: "step4section", setComponentProps: { is_visible: !0 } }] }, { actions: [{ onField: "step4section", setComponentProps: { is_visible: !1 } }] }] }], childFields: [{ fieldId: "has-referral", fieldName: "hasReferral", componentType: "checkbox-field", componentProps: { label: "Do you have a referral code?" } }, { fieldId: "referral-code", fieldName: "referralCode", componentType: "text-field", componentProps: { label: "Referral Code" }, conditionalRules: [{ if: [{ "==": [{ valueOfField: ["hasReferral"] }, !0] }, { actions: [{ onField: "referralCode", setFieldValidations: [{ ruleType: "required", ruleValue: !0, errorMessage: "Referral code is required" }] }] }, { actions: [{ onField: "referralCode", setFieldValidations: [] }] }] }] }] }, { fieldId: "step5section", fieldName: "step5section", componentType: "container", componentProps: { label: "Emergency Contact" }, conditionalRules: [{ if: [{ "==": [{ valueFromContext: "step" }, 5] }, { actions: [{ onField: "step5section", setComponentProps: { is_visible: !0 } }] }, { actions: [{ onField: "step5section", setComponentProps: { is_visible: !1 } }] }] }], childFields: [{ fieldId: "emergency-contact-name", fieldName: "emergencyContactName", componentType: "text-field", componentProps: { label: "Contact Name", placeholder: "Enter contact name" }, validationRules: [{ ruleType: "required", ruleValue: !0, errorMessage: "Contact name is required" }] }, { fieldId: "emergency-contact-phone", fieldName: "emergencyContactPhone", componentType: "text-field", componentProps: { label: "Contact Phone", placeholder: "Enter 10-digit phone number", type: "number" }, validationRules: [{ ruleType: "required", ruleValue: !0, errorMessage: "Contact phone is required" }, { ruleType: "pattern", ruleValue: "^\\d{10}$", errorMessage: "Enter a valid 10-digit phone number" }] }, { fieldId: "emergency-contact-relation", fieldName: "emergencyContactRelation", componentType: "select-field", componentProps: { label: "Relation", options: [{ label: "Parent", value: "parent" }, { label: "Sibling", value: "sibling" }, { label: "Spouse", value: "spouse" }, { label: "Friend", value: "friend" }, { label: "Other", value: "other" }] } }] }, { fieldId: "step6section", fieldName: "step6section", componentType: "container", componentProps: { label: "HR Details" }, conditionalRules: [{ if: [{ "==": [{ valueFromContext: "step" }, 6] }, { actions: [{ onField: "step6section", setComponentProps: { is_visible: !0 } }] }, { actions: [{ onField: "step6section", setComponentProps: { is_visible: !1 } }] }] }], childFields: [{ fieldId: "joining-date", fieldName: "joiningDate", componentType: "date-field", componentProps: { label: "Joining Date", placeholder: "Select joining date" }, validationRules: [{ ruleType: "required", ruleValue: !0, errorMessage: "Joining date is required" }] }, { fieldId: "department", fieldName: "department", componentType: "select-field", componentProps: { label: "Department", options: [{ label: "Engineering", value: "engineering" }, { label: "HR", value: "hr" }, { label: "Finance", value: "finance" }, { label: "Marketing", value: "marketing" }] } }, { fieldId: "step2-info", fieldName: "step2Info", componentType: "text-field", componentProps: { label: "Additional HR Notes", placeholder: "Enter any notes for HR" } }] }], Ye = {
  fieldId: Wd,
  fieldName: Bd,
  componentType: Hd,
  componentProps: qd,
  childFields: Ud
}, Kd = (e) => {
  const t = {}, r = (n) => {
    n.fieldName && (t[n.fieldName] = ""), n.childFields && n.childFields.forEach(r);
  };
  return r(e), t;
}, Gd = {
  container: ci,
  section: ui,
  "text-field": yo,
  "select-field": li,
  "checkbox-field": go,
  "radio-field": qo,
  "textarea-field": wo
  // 'date-field': DateField,
};
function Yd({ formInstance: e }) {
  const [t, r] = yr(1), [n, o] = yr(!1);
  Ii(() => {
    const i = Kd(Ye);
    e.reset(i), o(!0);
  }, [e]);
  const a = { step: t };
  return n ? /* @__PURE__ */ y.jsxs("div", { children: [
    /* @__PURE__ */ y.jsx(
      Fi,
      {
        schema: Ye,
        componentMapper: Gd,
        formInstance: e,
        context: a
      }
    ),
    /* @__PURE__ */ y.jsx("div", { style: { marginTop: 16, display: "flex", gap: 8 }, children: Array.from(
      { length: Ye == null ? void 0 : Ye.childFields.length },
      (i, s) => s + 1
    ).map((i) => /* @__PURE__ */ y.jsx(
      di,
      {
        className: "flex items-center gap-1.5 cursor-pointer hover:bg-[var(--primary)] hover:text-[var(--primary-foreground)]",
        variant: "outline",
        size: "sm",
        onClick: () => r(i),
        title: `Go to Step ${i}`,
        disabled: !Ye,
        children: /* @__PURE__ */ y.jsxs("span", { children: [
          "Step ",
          i
        ] })
      }
    )) })
  ] }) : /* @__PURE__ */ y.jsx("div", { children: "Loading..." });
}
const rf = [
  {
    label: "Employee Onboarding Form",
    value: "employee-onboarding-form",
    preview: Yd,
    schema: Ye
  }
];
export {
  rf as EXAMPLES
};
